import { g as Fa, B as Xt } from "./index-DhidOF4D.mjs";
var L;
(function(e) {
  e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
})(L || (L = {}));
function Ua(e) {
  return e.type === L.Tag || e.type === L.Script || e.type === L.Style;
}
const Ha = L.Root, wa = L.Text, va = L.Directive, Ya = L.Comment, qa = L.Script, Wa = L.Style, Qa = L.Tag, Ga = L.CDATA, Va = L.Doctype;
class _u {
  constructor() {
    this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(t) {
    this.parent = t;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(t) {
    this.prev = t;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(t) {
    this.next = t;
  }
  /**
   * Clone this node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(t = !1) {
    return ge(this, t);
  }
}
class It extends _u {
  /**
   * @param data The content of the data node
   */
  constructor(t) {
    super(), this.data = t;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(t) {
    this.data = t;
  }
}
class Au extends It {
  constructor() {
    super(...arguments), this.type = L.Text;
  }
  get nodeType() {
    return 3;
  }
}
class Xa extends It {
  constructor() {
    super(...arguments), this.type = L.Comment;
  }
  get nodeType() {
    return 8;
  }
}
class Ka extends It {
  constructor(t, u) {
    super(u), this.name = t, this.type = L.Directive;
  }
  get nodeType() {
    return 1;
  }
}
class St extends _u {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(t) {
    super(), this.children = t;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    var t;
    return (t = this.children[0]) !== null && t !== void 0 ? t : null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(t) {
    this.children = t;
  }
}
class ja extends St {
  constructor() {
    super(...arguments), this.type = L.CDATA;
  }
  get nodeType() {
    return 4;
  }
}
class Ot extends St {
  constructor() {
    super(...arguments), this.type = L.Root;
  }
  get nodeType() {
    return 9;
  }
}
class $a extends St {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  constructor(t, u, a = [], r = t === "script" ? L.Script : t === "style" ? L.Style : L.Tag) {
    super(a), this.name = t, this.attribs = u, this.type = r;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(t) {
    this.name = t;
  }
  get attributes() {
    return Object.keys(this.attribs).map((t) => {
      var u, a;
      return {
        name: t,
        value: this.attribs[t],
        namespace: (u = this["x-attribsNamespace"]) === null || u === void 0 ? void 0 : u[t],
        prefix: (a = this["x-attribsPrefix"]) === null || a === void 0 ? void 0 : a[t]
      };
    });
  }
}
function p(e) {
  return Ua(e);
}
function Ve(e) {
  return e.type === L.CDATA;
}
function Z(e) {
  return e.type === L.Text;
}
function Lt(e) {
  return e.type === L.Comment;
}
function za(e) {
  return e.type === L.Directive;
}
function te(e) {
  return e.type === L.Root;
}
function y(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
function ge(e, t = !1) {
  let u;
  if (Z(e))
    u = new Au(e.data);
  else if (Lt(e))
    u = new Xa(e.data);
  else if (p(e)) {
    const a = t ? rt(e.children) : [], r = new $a(e.name, { ...e.attribs }, a);
    a.forEach((n) => n.parent = r), e.namespace != null && (r.namespace = e.namespace), e["x-attribsNamespace"] && (r["x-attribsNamespace"] = { ...e["x-attribsNamespace"] }), e["x-attribsPrefix"] && (r["x-attribsPrefix"] = { ...e["x-attribsPrefix"] }), u = r;
  } else if (Ve(e)) {
    const a = t ? rt(e.children) : [], r = new ja(a);
    a.forEach((n) => n.parent = r), u = r;
  } else if (te(e)) {
    const a = t ? rt(e.children) : [], r = new Ot(a);
    a.forEach((n) => n.parent = r), e["x-mode"] && (r["x-mode"] = e["x-mode"]), u = r;
  } else if (za(e)) {
    const a = new Ka(e.name, e.data);
    e["x-name"] != null && (a["x-name"] = e["x-name"], a["x-publicId"] = e["x-publicId"], a["x-systemId"] = e["x-systemId"]), u = a;
  } else
    throw new Error(`Not implemented yet: ${e.type}`);
  return u.startIndex = e.startIndex, u.endIndex = e.endIndex, e.sourceCodeLocation != null && (u.sourceCodeLocation = e.sourceCodeLocation), u;
}
function rt(e) {
  const t = e.map((u) => ge(u, !0));
  for (let u = 1; u < t.length; u++)
    t[u].prev = t[u - 1], t[u - 1].next = t[u];
  return t;
}
const pu = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), Ja = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0))
);
var nt;
const Za = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), es = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (nt = String.fromCodePoint) !== null && nt !== void 0 ? nt : function(e) {
    let t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
  }
);
function ts(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = Za.get(e)) !== null && t !== void 0 ? t : e;
}
var x;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(x || (x = {}));
const us = 32;
var V;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(V || (V = {}));
function Tt(e) {
  return e >= x.ZERO && e <= x.NINE;
}
function as(e) {
  return e >= x.UPPER_A && e <= x.UPPER_F || e >= x.LOWER_A && e <= x.LOWER_F;
}
function ss(e) {
  return e >= x.UPPER_A && e <= x.UPPER_Z || e >= x.LOWER_A && e <= x.LOWER_Z || Tt(e);
}
function rs(e) {
  return e === x.EQUALS || ss(e);
}
var M;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(M || (M = {}));
var Q;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(Q || (Q = {}));
class gu {
  constructor(t, u, a) {
    this.decodeTree = t, this.emitCodePoint = u, this.errors = a, this.state = M.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Q.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = M.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, u) {
    switch (this.state) {
      case M.EntityStart:
        return t.charCodeAt(u) === x.NUM ? (this.state = M.NumericStart, this.consumed += 1, this.stateNumericStart(t, u + 1)) : (this.state = M.NamedEntity, this.stateNamedEntity(t, u));
      case M.NumericStart:
        return this.stateNumericStart(t, u);
      case M.NumericDecimal:
        return this.stateNumericDecimal(t, u);
      case M.NumericHex:
        return this.stateNumericHex(t, u);
      case M.NamedEntity:
        return this.stateNamedEntity(t, u);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, u) {
    return u >= t.length ? -1 : (t.charCodeAt(u) | us) === x.LOWER_X ? (this.state = M.NumericHex, this.consumed += 1, this.stateNumericHex(t, u + 1)) : (this.state = M.NumericDecimal, this.stateNumericDecimal(t, u));
  }
  addToNumericResult(t, u, a, r) {
    if (u !== a) {
      const n = a - u;
      this.result = this.result * Math.pow(r, n) + parseInt(t.substr(u, n), r), this.consumed += n;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, u) {
    const a = u;
    for (; u < t.length; ) {
      const r = t.charCodeAt(u);
      if (Tt(r) || as(r))
        u += 1;
      else
        return this.addToNumericResult(t, a, u, 16), this.emitNumericEntity(r, 3);
    }
    return this.addToNumericResult(t, a, u, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, u) {
    const a = u;
    for (; u < t.length; ) {
      const r = t.charCodeAt(u);
      if (Tt(r))
        u += 1;
      else
        return this.addToNumericResult(t, a, u, 10), this.emitNumericEntity(r, 2);
    }
    return this.addToNumericResult(t, a, u, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, u) {
    var a;
    if (this.consumed <= u)
      return (a = this.errors) === null || a === void 0 || a.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === x.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Q.Strict)
      return 0;
    return this.emitCodePoint(ts(this.result), this.consumed), this.errors && (t !== x.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, u) {
    const { decodeTree: a } = this;
    let r = a[this.treeIndex], n = (r & V.VALUE_LENGTH) >> 14;
    for (; u < t.length; u++, this.excess++) {
      const c = t.charCodeAt(u);
      if (this.treeIndex = ns(a, r, this.treeIndex + Math.max(1, n), c), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Q.Attribute && // We shouldn't have consumed any characters after the entity,
        (n === 0 || // And there should be no invalid characters.
        rs(c)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (r = a[this.treeIndex], n = (r & V.VALUE_LENGTH) >> 14, n !== 0) {
        if (c === x.SEMI)
          return this.emitNamedEntityData(this.treeIndex, n, this.consumed + this.excess);
        this.decodeMode !== Q.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: u, decodeTree: a } = this, r = (a[u] & V.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(u, r, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, u, a) {
    const { decodeTree: r } = this;
    return this.emitCodePoint(u === 1 ? r[t] & ~V.VALUE_LENGTH : r[t + 1], a), u === 3 && this.emitCodePoint(r[t + 2], a), a;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case M.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Q.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case M.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case M.NumericHex:
        return this.emitNumericEntity(0, 3);
      case M.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case M.EntityStart:
        return 0;
    }
  }
}
function Nu(e) {
  let t = "";
  const u = new gu(e, (a) => t += es(a));
  return function(r, n) {
    let c = 0, l = 0;
    for (; (l = r.indexOf("&", l)) >= 0; ) {
      t += r.slice(c, l), u.startEntity(n);
      const T = u.write(
        r,
        // Skip the "&"
        l + 1
      );
      if (T < 0) {
        c = l + u.end();
        break;
      }
      c = l + T, l = T === 0 ? c + 1 : c;
    }
    const h = t + r.slice(c);
    return t = "", h;
  };
}
function ns(e, t, u, a) {
  const r = (t & V.BRANCH_LENGTH) >> 7, n = t & V.JUMP_TABLE;
  if (r === 0)
    return n !== 0 && a === n ? u : -1;
  if (n) {
    const h = a - n;
    return h < 0 || h >= r ? -1 : e[u + h] - 1;
  }
  let c = u, l = c + r - 1;
  for (; c <= l; ) {
    const h = c + l >>> 1, T = e[h];
    if (T < a)
      c = h + 1;
    else if (T > a)
      l = h - 1;
    else
      return e[h + r];
  }
  return -1;
}
Nu(pu);
Nu(Ja);
const Kt = /["&'<>$\x80-\uFFFF]/g, is = /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [39, "&apos;"],
  [60, "&lt;"],
  [62, "&gt;"]
]), cs = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (e, t) => e.codePointAt(t) : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    (e, t) => (e.charCodeAt(t) & 64512) === 55296 ? (e.charCodeAt(t) - 55296) * 1024 + e.charCodeAt(t + 1) - 56320 + 65536 : e.charCodeAt(t)
  )
);
function Cu(e) {
  let t = "", u = 0, a;
  for (; (a = Kt.exec(e)) !== null; ) {
    const r = a.index, n = e.charCodeAt(r), c = is.get(n);
    c !== void 0 ? (t += e.substring(u, r) + c, u = r + 1) : (t += `${e.substring(u, r)}&#x${cs(e, r).toString(16)};`, u = Kt.lastIndex += +((n & 64512) === 55296));
  }
  return t + e.substr(u);
}
function Iu(e, t) {
  return function(a) {
    let r, n = 0, c = "";
    for (; r = e.exec(a); )
      n !== r.index && (c += a.substring(n, r.index)), c += t.get(r[0].charCodeAt(0)), n = r.index + 1;
    return c + a.substring(n);
  };
}
const Su = Iu(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
])), Ou = Iu(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
])), os = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), ds = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), ls = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function fs(e) {
  return e.replace(/"/g, "&quot;");
}
function hs(e, t) {
  var u;
  if (!e)
    return;
  const a = ((u = t.encodeEntities) !== null && u !== void 0 ? u : t.decodeEntities) === !1 ? fs : t.xmlMode || t.encodeEntities !== "utf8" ? Cu : Su;
  return Object.keys(e).map((r) => {
    var n, c;
    const l = (n = e[r]) !== null && n !== void 0 ? n : "";
    return t.xmlMode === "foreign" && (r = (c = ds.get(r)) !== null && c !== void 0 ? c : r), !t.emptyAttrs && !t.xmlMode && l === "" ? r : `${r}="${a(l)}"`;
  }).join(" ");
}
const jt = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function Dt(e, t = {}) {
  const u = "length" in e ? e : [e];
  let a = "";
  for (let r = 0; r < u.length; r++)
    a += Es(u[r], t);
  return a;
}
function Es(e, t) {
  switch (e.type) {
    case Ha:
      return Dt(e.children, t);
    case Va:
    case va:
      return _s(e);
    case Ya:
      return gs(e);
    case Ga:
      return ps(e);
    case qa:
    case Wa:
    case Qa:
      return ms(e, t);
    case wa:
      return As(e, t);
  }
}
const Ts = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), bs = /* @__PURE__ */ new Set(["svg", "math"]);
function ms(e, t) {
  var u;
  t.xmlMode === "foreign" && (e.name = (u = os.get(e.name)) !== null && u !== void 0 ? u : e.name, e.parent && Ts.has(e.parent.name) && (t = { ...t, xmlMode: !1 })), !t.xmlMode && bs.has(e.name) && (t = { ...t, xmlMode: "foreign" });
  let a = `<${e.name}`;
  const r = hs(e.attribs, t);
  return r && (a += ` ${r}`), e.children.length === 0 && (t.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    t.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    t.selfClosingTags && jt.has(e.name)
  )) ? (t.xmlMode || (a += " "), a += "/>") : (a += ">", e.children.length > 0 && (a += Dt(e.children, t)), (t.xmlMode || !jt.has(e.name)) && (a += `</${e.name}>`)), a;
}
function _s(e) {
  return `<${e.data}>`;
}
function As(e, t) {
  var u;
  let a = e.data || "";
  return ((u = t.encodeEntities) !== null && u !== void 0 ? u : t.decodeEntities) !== !1 && !(!t.xmlMode && e.parent && ls.has(e.parent.name)) && (a = t.xmlMode || t.encodeEntities !== "utf8" ? Cu(a) : Ou(a)), a;
}
function ps(e) {
  return `<![CDATA[${e.children[0].data}]]>`;
}
function gs(e) {
  return `<!--${e.data}-->`;
}
function Lu(e, t) {
  return Dt(e, t);
}
function Ns(e, t) {
  return y(e) ? e.children.map((u) => Lu(u, t)).join("") : "";
}
function ye(e) {
  return Array.isArray(e) ? e.map(ye).join("") : p(e) ? e.name === "br" ? `
` : ye(e.children) : Ve(e) ? ye(e.children) : Z(e) ? e.data : "";
}
function re(e) {
  return Array.isArray(e) ? e.map(re).join("") : y(e) && !Lt(e) ? re(e.children) : Z(e) ? e.data : "";
}
function ke(e) {
  return Array.isArray(e) ? e.map(ke).join("") : y(e) && (e.type === L.Tag || Ve(e)) ? ke(e.children) : Z(e) ? e.data : "";
}
function Xe(e) {
  return y(e) ? e.children : [];
}
function Du(e) {
  return e.parent || null;
}
function Ru(e) {
  const t = Du(e);
  if (t != null)
    return Xe(t);
  const u = [e];
  let { prev: a, next: r } = e;
  for (; a != null; )
    u.unshift(a), { prev: a } = a;
  for (; r != null; )
    u.push(r), { next: r } = r;
  return u;
}
function Cs(e, t) {
  var u;
  return (u = e.attribs) === null || u === void 0 ? void 0 : u[t];
}
function Is(e, t) {
  return e.attribs != null && Object.prototype.hasOwnProperty.call(e.attribs, t) && e.attribs[t] != null;
}
function Ss(e) {
  return e.name;
}
function Rt(e) {
  let { next: t } = e;
  for (; t !== null && !p(t); )
    ({ next: t } = t);
  return t;
}
function Pt(e) {
  let { prev: t } = e;
  for (; t !== null && !p(t); )
    ({ prev: t } = t);
  return t;
}
function ue(e) {
  if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
    const t = e.parent.children, u = t.lastIndexOf(e);
    u >= 0 && t.splice(u, 1);
  }
  e.next = null, e.prev = null, e.parent = null;
}
function Os(e, t) {
  const u = t.prev = e.prev;
  u && (u.next = t);
  const a = t.next = e.next;
  a && (a.prev = t);
  const r = t.parent = e.parent;
  if (r) {
    const n = r.children;
    n[n.lastIndexOf(e)] = t, e.parent = null;
  }
}
function Ls(e, t) {
  if (ue(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
    const u = e.children[e.children.length - 2];
    u.next = t, t.prev = u;
  } else
    t.prev = null;
}
function Ds(e, t) {
  ue(t);
  const { parent: u } = e, a = e.next;
  if (t.next = a, t.prev = e, e.next = t, t.parent = u, a) {
    if (a.prev = t, u) {
      const r = u.children;
      r.splice(r.lastIndexOf(a), 0, t);
    }
  } else u && u.children.push(t);
}
function Rs(e, t) {
  if (ue(t), t.parent = e, t.prev = null, e.children.unshift(t) !== 1) {
    const u = e.children[1];
    u.prev = t, t.next = u;
  } else
    t.next = null;
}
function Ps(e, t) {
  ue(t);
  const { parent: u } = e;
  if (u) {
    const a = u.children;
    a.splice(a.indexOf(e), 0, t);
  }
  e.prev && (e.prev.next = t), t.parent = u, t.prev = e.prev, t.next = e, e.prev = t;
}
function Ke(e, t, u = !0, a = 1 / 0) {
  return Mt(e, Array.isArray(t) ? t : [t], u, a);
}
function Mt(e, t, u, a) {
  const r = [], n = [t], c = [0];
  for (; ; ) {
    if (c[0] >= n[0].length) {
      if (c.length === 1)
        return r;
      n.shift(), c.shift();
      continue;
    }
    const l = n[0][c[0]++];
    if (e(l) && (r.push(l), --a <= 0))
      return r;
    u && y(l) && l.children.length > 0 && (c.unshift(0), n.unshift(l.children));
  }
}
function Ms(e, t) {
  return t.find(e);
}
function xt(e, t, u = !0) {
  let a = null;
  for (let r = 0; r < t.length && !a; r++) {
    const n = t[r];
    if (p(n))
      e(n) ? a = n : u && n.children.length > 0 && (a = xt(e, n.children, !0));
    else continue;
  }
  return a;
}
function Pu(e, t) {
  return t.some((u) => p(u) && (e(u) || Pu(e, u.children)));
}
function xs(e, t) {
  const u = [], a = [t], r = [0];
  for (; ; ) {
    if (r[0] >= a[0].length) {
      if (a.length === 1)
        return u;
      a.shift(), r.shift();
      continue;
    }
    const n = a[0][r[0]++];
    p(n) && (e(n) && u.push(n), n.children.length > 0 && (r.unshift(0), a.unshift(n.children)));
  }
}
const Fe = {
  tag_name(e) {
    return typeof e == "function" ? (t) => p(t) && e(t.name) : e === "*" ? p : (t) => p(t) && t.name === e;
  },
  tag_type(e) {
    return typeof e == "function" ? (t) => e(t.type) : (t) => t.type === e;
  },
  tag_contains(e) {
    return typeof e == "function" ? (t) => Z(t) && e(t.data) : (t) => Z(t) && t.data === e;
  }
};
function Mu(e, t) {
  return typeof t == "function" ? (u) => p(u) && t(u.attribs[e]) : (u) => p(u) && u.attribs[e] === t;
}
function ys(e, t) {
  return (u) => e(u) || t(u);
}
function xu(e) {
  const t = Object.keys(e).map((u) => {
    const a = e[u];
    return Object.prototype.hasOwnProperty.call(Fe, u) ? Fe[u](a) : Mu(u, a);
  });
  return t.length === 0 ? null : t.reduce(ys);
}
function Bs(e, t) {
  const u = xu(e);
  return u ? u(t) : !0;
}
function ks(e, t, u, a = 1 / 0) {
  const r = xu(e);
  return r ? Ke(r, t, u, a) : [];
}
function Fs(e, t, u = !0) {
  return Array.isArray(t) || (t = [t]), xt(Mu("id", e), t, u);
}
function ie(e, t, u = !0, a = 1 / 0) {
  return Ke(Fe.tag_name(e), t, u, a);
}
function Us(e, t, u = !0, a = 1 / 0) {
  return Ke(Fe.tag_type(e), t, u, a);
}
function Hs(e) {
  let t = e.length;
  for (; --t >= 0; ) {
    const u = e[t];
    if (t > 0 && e.lastIndexOf(u, t - 1) >= 0) {
      e.splice(t, 1);
      continue;
    }
    for (let a = u.parent; a; a = a.parent)
      if (e.includes(a)) {
        e.splice(t, 1);
        break;
      }
  }
  return e;
}
var w;
(function(e) {
  e[e.DISCONNECTED = 1] = "DISCONNECTED", e[e.PRECEDING = 2] = "PRECEDING", e[e.FOLLOWING = 4] = "FOLLOWING", e[e.CONTAINS = 8] = "CONTAINS", e[e.CONTAINED_BY = 16] = "CONTAINED_BY";
})(w || (w = {}));
function yu(e, t) {
  const u = [], a = [];
  if (e === t)
    return 0;
  let r = y(e) ? e : e.parent;
  for (; r; )
    u.unshift(r), r = r.parent;
  for (r = y(t) ? t : t.parent; r; )
    a.unshift(r), r = r.parent;
  const n = Math.min(u.length, a.length);
  let c = 0;
  for (; c < n && u[c] === a[c]; )
    c++;
  if (c === 0)
    return w.DISCONNECTED;
  const l = u[c - 1], h = l.children, T = u[c], _ = a[c];
  return h.indexOf(T) > h.indexOf(_) ? l === t ? w.FOLLOWING | w.CONTAINED_BY : w.FOLLOWING : l === e ? w.PRECEDING | w.CONTAINS : w.PRECEDING;
}
function ce(e) {
  return e = e.filter((t, u, a) => !a.includes(t, u + 1)), e.sort((t, u) => {
    const a = yu(t, u);
    return a & w.PRECEDING ? -1 : a & w.FOLLOWING ? 1 : 0;
  }), e;
}
function ws(e) {
  const t = Ue(Qs, e);
  return t ? t.name === "feed" ? vs(t) : Ys(t) : null;
}
function vs(e) {
  var t;
  const u = e.children, a = {
    type: "atom",
    items: ie("entry", u).map((c) => {
      var l;
      const { children: h } = c, T = { media: Bu(h) };
      U(T, "id", "id", h), U(T, "title", "title", h);
      const _ = (l = Ue("link", h)) === null || l === void 0 ? void 0 : l.attribs.href;
      _ && (T.link = _);
      const I = X("summary", h) || X("content", h);
      I && (T.description = I);
      const g = X("updated", h);
      return g && (T.pubDate = new Date(g)), T;
    })
  };
  U(a, "id", "id", u), U(a, "title", "title", u);
  const r = (t = Ue("link", u)) === null || t === void 0 ? void 0 : t.attribs.href;
  r && (a.link = r), U(a, "description", "subtitle", u);
  const n = X("updated", u);
  return n && (a.updated = new Date(n)), U(a, "author", "email", u, !0), a;
}
function Ys(e) {
  var t, u;
  const a = (u = (t = Ue("channel", e.children)) === null || t === void 0 ? void 0 : t.children) !== null && u !== void 0 ? u : [], r = {
    type: e.name.substr(0, 3),
    id: "",
    items: ie("item", e.children).map((c) => {
      const { children: l } = c, h = { media: Bu(l) };
      U(h, "id", "guid", l), U(h, "title", "title", l), U(h, "link", "link", l), U(h, "description", "description", l);
      const T = X("pubDate", l) || X("dc:date", l);
      return T && (h.pubDate = new Date(T)), h;
    })
  };
  U(r, "title", "title", a), U(r, "link", "link", a), U(r, "description", "description", a);
  const n = X("lastBuildDate", a);
  return n && (r.updated = new Date(n)), U(r, "author", "managingEditor", a, !0), r;
}
const qs = ["url", "type", "lang"], Ws = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function Bu(e) {
  return ie("media:content", e).map((t) => {
    const { attribs: u } = t, a = {
      medium: u.medium,
      isDefault: !!u.isDefault
    };
    for (const r of qs)
      u[r] && (a[r] = u[r]);
    for (const r of Ws)
      u[r] && (a[r] = parseInt(u[r], 10));
    return u.expression && (a.expression = u.expression), a;
  });
}
function Ue(e, t) {
  return ie(e, t, !0, 1)[0];
}
function X(e, t, u = !1) {
  return re(ie(e, t, u, 1)).trim();
}
function U(e, t, u, a, r = !1) {
  const n = X(u, a, r);
  n && (e[t] = n);
}
function Qs(e) {
  return e === "rss" || e === "feed" || e === "rdf:RDF";
}
const je = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DocumentPosition() {
    return w;
  },
  append: Ds,
  appendChild: Ls,
  compareDocumentPosition: yu,
  existsOne: Pu,
  filter: Ke,
  find: Mt,
  findAll: xs,
  findOne: xt,
  findOneChild: Ms,
  getAttributeValue: Cs,
  getChildren: Xe,
  getElementById: Fs,
  getElements: ks,
  getElementsByTagName: ie,
  getElementsByTagType: Us,
  getFeed: ws,
  getInnerHTML: Ns,
  getName: Ss,
  getOuterHTML: Lu,
  getParent: Du,
  getSiblings: Ru,
  getText: ye,
  hasAttrib: Is,
  hasChildren: y,
  innerText: ke,
  isCDATA: Ve,
  isComment: Lt,
  isDocument: te,
  isTag: p,
  isText: Z,
  nextElementSibling: Rt,
  prepend: Ps,
  prependChild: Rs,
  prevElementSibling: Pt,
  removeElement: ue,
  removeSubsets: Hs,
  replaceElement: Os,
  testElement: Bs,
  textContent: re,
  uniqueSort: ce
}, Symbol.toStringTag, { value: "Module" })), Gs = {
  _useHtmlParser2: !1
};
function Vs(e, t) {
  if (!e)
    return t ?? Gs;
  const u = {
    _useHtmlParser2: !!e.xmlMode,
    ...t,
    ...e
  };
  return e.xml ? (u._useHtmlParser2 = !0, u.xmlMode = !0, e.xml !== !0 && Object.assign(u, e.xml)) : e.xmlMode && (u._useHtmlParser2 = !0), u;
}
function ku(e, t, u) {
  return e ? e(t ?? e._root.children, null, void 0, u).toString() : "";
}
function Xs(e, t) {
  return typeof e == "object" && e != null && !("length" in e) && !("type" in e);
}
function Ks(e, t) {
  const u = Xs(e) ? (t = e, void 0) : e, a = {
    ...this === null || this === void 0 ? void 0 : this._options,
    ...Vs(t)
  };
  return ku(this, u, a);
}
function js(e) {
  const t = { ...this._options, xmlMode: !0 };
  return ku(this, e, t);
}
function Ne(e) {
  const t = e ?? (this ? this.root() : []);
  let u = "";
  for (let a = 0; a < t.length; a++)
    u += re(t[a]);
  return u;
}
function $s(e, t, u = typeof t == "boolean" ? t : !1) {
  if (!e || typeof e != "string")
    return null;
  typeof t == "boolean" && (u = t);
  const a = this.load(e, this._options, !1);
  return u || a("script").remove(), [...a.root()[0].children];
}
function zs() {
  return this(this._root);
}
function Fu(e, t) {
  if (t === e)
    return !1;
  let u = t;
  for (; u && u !== u.parent; )
    if (u = u.parent, u === e)
      return !0;
  return !1;
}
function Js(e) {
  return this.root().extract(e);
}
function Zs(e, t) {
  if (!$t(e) || !$t(t))
    return;
  let u = e.length;
  const a = +t.length;
  for (let r = 0; r < a; r++)
    e[u++] = t[r];
  return e.length = u, e;
}
function $t(e) {
  if (Array.isArray(e))
    return !0;
  if (typeof e != "object" || e === null || !("length" in e) || typeof e.length != "number" || e.length < 0)
    return !1;
  for (let t = 0; t < e.length; t++)
    if (!(t in e))
      return !1;
  return !0;
}
const U0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  contains: Fu,
  extract: Js,
  html: Ks,
  merge: Zs,
  parseHTML: $s,
  root: zs,
  text: Ne,
  xml: js
}, Symbol.toStringTag, { value: "Module" }));
function oe(e) {
  return e.cheerio != null;
}
function er(e) {
  return e.replace(/[._-](\w|$)/g, (t, u) => u.toUpperCase());
}
function tr(e) {
  return e.replace(/[A-Z]/g, "-$&").toLowerCase();
}
function R(e, t) {
  const u = e.length;
  for (let a = 0; a < u; a++)
    t(e[a], a);
  return e;
}
var z;
(function(e) {
  e[e.LowerA = 97] = "LowerA", e[e.LowerZ = 122] = "LowerZ", e[e.UpperA = 65] = "UpperA", e[e.UpperZ = 90] = "UpperZ", e[e.Exclamation = 33] = "Exclamation";
})(z || (z = {}));
function ur(e) {
  const t = e.indexOf("<");
  if (t < 0 || t > e.length - 3)
    return !1;
  const u = e.charCodeAt(t + 1);
  return (u >= z.LowerA && u <= z.LowerZ || u >= z.UpperA && u <= z.UpperZ || u === z.Exclamation) && e.includes(">", t + 2);
}
const Ce = Object.prototype.hasOwnProperty, Ie = /\s+/, bt = "data-", yt = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i, ar = /^{[^]*}$|^\[[^]*]$/;
function He(e, t, u) {
  var a;
  if (!(!e || !p(e))) {
    if ((a = e.attribs) !== null && a !== void 0 || (e.attribs = {}), !t)
      return e.attribs;
    if (Ce.call(e.attribs, t))
      return !u && yt.test(t) ? t : e.attribs[t];
    if (e.name === "option" && t === "value")
      return Ne(e.children);
    if (e.name === "input" && (e.attribs.type === "radio" || e.attribs.type === "checkbox") && t === "value")
      return "on";
  }
}
function se(e, t, u) {
  u === null ? Hu(e, t) : e.attribs[t] = `${u}`;
}
function sr(e, t) {
  if (typeof e == "object" || t !== void 0) {
    if (typeof t == "function") {
      if (typeof e != "string")
        throw new Error("Bad combination of arguments.");
      return R(this, (u, a) => {
        p(u) && se(u, e, t.call(u, a, u.attribs[e]));
      });
    }
    return R(this, (u) => {
      if (p(u))
        if (typeof e == "object")
          for (const a of Object.keys(e)) {
            const r = e[a];
            se(u, a, r);
          }
        else
          se(u, e, t);
    });
  }
  return arguments.length > 1 ? this : He(this[0], e, this.options.xmlMode);
}
function zt(e, t, u) {
  return t in e ? (
    // @ts-expect-error TS doesn't like us accessing the value directly here.
    e[t]
  ) : !u && yt.test(t) ? He(e, t, !1) !== void 0 : He(e, t, u);
}
function it(e, t, u, a) {
  t in e ? e[t] = u : se(e, t, !a && yt.test(t) ? u ? "" : null : `${u}`);
}
function rr(e, t) {
  var u;
  if (typeof e == "string" && t === void 0) {
    const a = this[0];
    if (!a || !p(a))
      return;
    switch (e) {
      case "style": {
        const r = this.css(), n = Object.keys(r);
        for (let c = 0; c < n.length; c++)
          r[c] = n[c];
        return r.length = n.length, r;
      }
      case "tagName":
      case "nodeName":
        return a.name.toUpperCase();
      case "href":
      case "src": {
        const r = (u = a.attribs) === null || u === void 0 ? void 0 : u[e];
        return typeof URL < "u" && (e === "href" && (a.tagName === "a" || a.tagName === "link") || e === "src" && (a.tagName === "img" || a.tagName === "iframe" || a.tagName === "audio" || a.tagName === "video" || a.tagName === "source")) && r !== void 0 && this.options.baseURI ? new URL(r, this.options.baseURI).href : r;
      }
      case "innerText":
        return ke(a);
      case "textContent":
        return re(a);
      case "outerHTML":
        return this.clone().wrap("<container />").parent().html();
      case "innerHTML":
        return this.html();
      default:
        return zt(a, e, this.options.xmlMode);
    }
  }
  if (typeof e == "object" || t !== void 0) {
    if (typeof t == "function") {
      if (typeof e == "object")
        throw new TypeError("Bad combination of arguments.");
      return R(this, (a, r) => {
        p(a) && it(a, e, t.call(a, r, zt(a, e, this.options.xmlMode)), this.options.xmlMode);
      });
    }
    return R(this, (a) => {
      if (p(a))
        if (typeof e == "object")
          for (const r of Object.keys(e)) {
            const n = e[r];
            it(a, r, n, this.options.xmlMode);
          }
        else
          it(a, e, t, this.options.xmlMode);
    });
  }
}
function Jt(e, t, u) {
  var a;
  (a = e.data) !== null && a !== void 0 || (e.data = {}), typeof t == "object" ? Object.assign(e.data, t) : typeof t == "string" && u !== void 0 && (e.data[t] = u);
}
function nr(e) {
  for (const t of Object.keys(e.attribs)) {
    if (!t.startsWith(bt))
      continue;
    const u = er(t.slice(bt.length));
    Ce.call(e.data, u) || (e.data[u] = Uu(e.attribs[t]));
  }
  return e.data;
}
function ir(e, t) {
  const u = bt + tr(t), a = e.data;
  if (Ce.call(a, t))
    return a[t];
  if (Ce.call(e.attribs, u))
    return a[t] = Uu(e.attribs[u]);
}
function Uu(e) {
  if (e === "null")
    return null;
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  const t = Number(e);
  if (e === String(t))
    return t;
  if (ar.test(e))
    try {
      return JSON.parse(e);
    } catch {
    }
  return e;
}
function cr(e, t) {
  var u;
  const a = this[0];
  if (!a || !p(a))
    return;
  const r = a;
  return (u = r.data) !== null && u !== void 0 || (r.data = {}), e == null ? nr(r) : typeof e == "object" || t !== void 0 ? (R(this, (n) => {
    p(n) && (typeof e == "object" ? Jt(n, e) : Jt(n, e, t));
  }), this) : ir(r, e);
}
function or(e) {
  const t = arguments.length === 0, u = this[0];
  if (!u || !p(u))
    return t ? void 0 : this;
  switch (u.name) {
    case "textarea":
      return this.text(e);
    case "select": {
      const a = this.find("option:selected");
      if (!t) {
        if (this.attr("multiple") == null && typeof e == "object")
          return this;
        this.find("option").removeAttr("selected");
        const r = typeof e == "object" ? e : [e];
        for (const n of r)
          this.find(`option[value="${n}"]`).attr("selected", "");
        return this;
      }
      return this.attr("multiple") ? a.toArray().map((r) => Ne(r.children)) : a.attr("value");
    }
    case "input":
    case "option":
      return t ? this.attr("value") : this.attr("value", e);
  }
}
function Hu(e, t) {
  !e.attribs || !Ce.call(e.attribs, t) || delete e.attribs[t];
}
function we(e) {
  return e ? e.trim().split(Ie) : [];
}
function dr(e) {
  const t = we(e);
  for (const u of t)
    R(this, (a) => {
      p(a) && Hu(a, u);
    });
  return this;
}
function lr(e) {
  return this.toArray().some((t) => {
    const u = p(t) && t.attribs.class;
    let a = -1;
    if (u && e.length > 0)
      for (; (a = u.indexOf(e, a + 1)) > -1; ) {
        const r = a + e.length;
        if ((a === 0 || Ie.test(u[a - 1])) && (r === u.length || Ie.test(u[r])))
          return !0;
      }
    return !1;
  });
}
function wu(e) {
  if (typeof e == "function")
    return R(this, (a, r) => {
      if (p(a)) {
        const n = a.attribs.class || "";
        wu.call([a], e.call(a, r, n));
      }
    });
  if (!e || typeof e != "string")
    return this;
  const t = e.split(Ie), u = this.length;
  for (let a = 0; a < u; a++) {
    const r = this[a];
    if (!p(r))
      continue;
    const n = He(r, "class", !1);
    if (n) {
      let c = ` ${n} `;
      for (const l of t) {
        const h = `${l} `;
        c.includes(` ${h}`) || (c += h);
      }
      se(r, "class", c.trim());
    } else
      se(r, "class", t.join(" ").trim());
  }
  return this;
}
function vu(e) {
  if (typeof e == "function")
    return R(this, (r, n) => {
      p(r) && vu.call([r], e.call(r, n, r.attribs.class || ""));
    });
  const t = we(e), u = t.length, a = arguments.length === 0;
  return R(this, (r) => {
    if (p(r))
      if (a)
        r.attribs.class = "";
      else {
        const n = we(r.attribs.class);
        let c = !1;
        for (let l = 0; l < u; l++) {
          const h = n.indexOf(t[l]);
          h >= 0 && (n.splice(h, 1), c = !0, l--);
        }
        c && (r.attribs.class = n.join(" "));
      }
  });
}
function Yu(e, t) {
  if (typeof e == "function")
    return R(this, (c, l) => {
      p(c) && Yu.call([c], e.call(c, l, c.attribs.class || "", t), t);
    });
  if (!e || typeof e != "string")
    return this;
  const u = e.split(Ie), a = u.length, r = typeof t == "boolean" ? t ? 1 : -1 : 0, n = this.length;
  for (let c = 0; c < n; c++) {
    const l = this[c];
    if (!p(l))
      continue;
    const h = we(l.attribs.class);
    for (let T = 0; T < a; T++) {
      const _ = h.indexOf(u[T]);
      r >= 0 && _ < 0 ? h.push(u[T]) : r <= 0 && _ >= 0 && h.splice(_, 1);
    }
    l.attribs.class = h.join(" ");
  }
  return this;
}
const fr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addClass: wu,
  attr: sr,
  data: cr,
  hasClass: lr,
  prop: rr,
  removeAttr: dr,
  removeClass: vu,
  toggleClass: Yu,
  val: or
}, Symbol.toStringTag, { value: "Module" }));
var A;
(function(e) {
  e.Attribute = "attribute", e.Pseudo = "pseudo", e.PseudoElement = "pseudo-element", e.Tag = "tag", e.Universal = "universal", e.Adjacent = "adjacent", e.Child = "child", e.Descendant = "descendant", e.Parent = "parent", e.Sibling = "sibling", e.ColumnCombinator = "column-combinator";
})(A || (A = {}));
var P;
(function(e) {
  e.Any = "any", e.Element = "element", e.End = "end", e.Equals = "equals", e.Exists = "exists", e.Hyphen = "hyphen", e.Not = "not", e.Start = "start";
})(P || (P = {}));
const Zt = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/, hr = /\\([\da-f]{1,6}\s?|(\s)|.)/gi, Er = /* @__PURE__ */ new Map([
  [126, P.Element],
  [94, P.Start],
  [36, P.End],
  [42, P.Any],
  [33, P.Not],
  [124, P.Hyphen]
]), Tr = /* @__PURE__ */ new Set([
  "has",
  "not",
  "matches",
  "is",
  "where",
  "host",
  "host-context"
]);
function Te(e) {
  switch (e.type) {
    case A.Adjacent:
    case A.Child:
    case A.Descendant:
    case A.Parent:
    case A.Sibling:
    case A.ColumnCombinator:
      return !0;
    default:
      return !1;
  }
}
const br = /* @__PURE__ */ new Set(["contains", "icontains"]);
function mr(e, t, u) {
  const a = parseInt(t, 16) - 65536;
  return a !== a || u ? t : a < 0 ? (
    // BMP codepoint
    String.fromCharCode(a + 65536)
  ) : (
    // Supplemental Plane codepoint (surrogate pair)
    String.fromCharCode(a >> 10 | 55296, a & 1023 | 56320)
  );
}
function le(e) {
  return e.replace(hr, mr);
}
function ct(e) {
  return e === 39 || e === 34;
}
function eu(e) {
  return e === 32 || e === 9 || e === 10 || e === 12 || e === 13;
}
function $e(e) {
  const t = [], u = qu(t, `${e}`, 0);
  if (u < e.length)
    throw new Error(`Unmatched selector: ${e.slice(u)}`);
  return t;
}
function qu(e, t, u) {
  let a = [];
  function r(g) {
    const N = t.slice(u + g).match(Zt);
    if (!N)
      throw new Error(`Expected name, found ${t.slice(u)}`);
    const [S] = N;
    return u += g + S.length, le(S);
  }
  function n(g) {
    for (u += g; u < t.length && eu(t.charCodeAt(u)); )
      u++;
  }
  function c() {
    u += 1;
    const g = u;
    let N = 1;
    for (; N > 0 && u < t.length; u++)
      t.charCodeAt(u) === 40 && !l(u) ? N++ : t.charCodeAt(u) === 41 && !l(u) && N--;
    if (N)
      throw new Error("Parenthesis not matched");
    return le(t.slice(g, u - 1));
  }
  function l(g) {
    let N = 0;
    for (; t.charCodeAt(--g) === 92; )
      N++;
    return (N & 1) === 1;
  }
  function h() {
    if (a.length > 0 && Te(a[a.length - 1]))
      throw new Error("Did not expect successive traversals.");
  }
  function T(g) {
    if (a.length > 0 && a[a.length - 1].type === A.Descendant) {
      a[a.length - 1].type = g;
      return;
    }
    h(), a.push({ type: g });
  }
  function _(g, N) {
    a.push({
      type: A.Attribute,
      name: g,
      action: N,
      value: r(1),
      namespace: null,
      ignoreCase: "quirks"
    });
  }
  function I() {
    if (a.length && a[a.length - 1].type === A.Descendant && a.pop(), a.length === 0)
      throw new Error("Empty sub-selector");
    e.push(a);
  }
  if (n(0), t.length === u)
    return u;
  e: for (; u < t.length; ) {
    const g = t.charCodeAt(u);
    switch (g) {
      case 32:
      case 9:
      case 10:
      case 12:
      case 13: {
        (a.length === 0 || a[0].type !== A.Descendant) && (h(), a.push({ type: A.Descendant })), n(1);
        break;
      }
      case 62: {
        T(A.Child), n(1);
        break;
      }
      case 60: {
        T(A.Parent), n(1);
        break;
      }
      case 126: {
        T(A.Sibling), n(1);
        break;
      }
      case 43: {
        T(A.Adjacent), n(1);
        break;
      }
      case 46: {
        _("class", P.Element);
        break;
      }
      case 35: {
        _("id", P.Equals);
        break;
      }
      case 91: {
        n(1);
        let N, S = null;
        t.charCodeAt(u) === 124 ? N = r(1) : t.startsWith("*|", u) ? (S = "*", N = r(2)) : (N = r(0), t.charCodeAt(u) === 124 && t.charCodeAt(u + 1) !== 61 && (S = N, N = r(1))), n(0);
        let k = P.Exists;
        const Gt = Er.get(t.charCodeAt(u));
        if (Gt) {
          if (k = Gt, t.charCodeAt(u + 1) !== 61)
            throw new Error("Expected `=`");
          n(2);
        } else t.charCodeAt(u) === 61 && (k = P.Equals, n(1));
        let at = "", st = null;
        if (k !== "exists") {
          if (ct(t.charCodeAt(u))) {
            const Re = t.charCodeAt(u);
            let j = u + 1;
            for (; j < t.length && (t.charCodeAt(j) !== Re || l(j)); )
              j += 1;
            if (t.charCodeAt(j) !== Re)
              throw new Error("Attribute value didn't end");
            at = le(t.slice(u + 1, j)), u = j + 1;
          } else {
            const Re = u;
            for (; u < t.length && (!eu(t.charCodeAt(u)) && t.charCodeAt(u) !== 93 || l(u)); )
              u += 1;
            at = le(t.slice(Re, u));
          }
          n(0);
          const Vt = t.charCodeAt(u) | 32;
          Vt === 115 ? (st = !1, n(1)) : Vt === 105 && (st = !0, n(1));
        }
        if (t.charCodeAt(u) !== 93)
          throw new Error("Attribute selector didn't terminate");
        u += 1;
        const ka = {
          type: A.Attribute,
          name: N,
          action: k,
          value: at,
          namespace: S,
          ignoreCase: st
        };
        a.push(ka);
        break;
      }
      case 58: {
        if (t.charCodeAt(u + 1) === 58) {
          a.push({
            type: A.PseudoElement,
            name: r(2).toLowerCase(),
            data: t.charCodeAt(u) === 40 ? c() : null
          });
          continue;
        }
        const N = r(1).toLowerCase();
        let S = null;
        if (t.charCodeAt(u) === 40)
          if (Tr.has(N)) {
            if (ct(t.charCodeAt(u + 1)))
              throw new Error(`Pseudo-selector ${N} cannot be quoted`);
            if (S = [], u = qu(S, t, u + 1), t.charCodeAt(u) !== 41)
              throw new Error(`Missing closing parenthesis in :${N} (${t})`);
            u += 1;
          } else {
            if (S = c(), br.has(N)) {
              const k = S.charCodeAt(0);
              k === S.charCodeAt(S.length - 1) && ct(k) && (S = S.slice(1, -1));
            }
            S = le(S);
          }
        a.push({ type: A.Pseudo, name: N, data: S });
        break;
      }
      case 44: {
        I(), a = [], n(1);
        break;
      }
      default: {
        if (t.startsWith("/*", u)) {
          const k = t.indexOf("*/", u + 2);
          if (k < 0)
            throw new Error("Comment was not terminated");
          u = k + 2, a.length === 0 && n(0);
          break;
        }
        let N = null, S;
        if (g === 42)
          u += 1, S = "*";
        else if (g === 124) {
          if (S = "", t.charCodeAt(u + 1) === 124) {
            T(A.ColumnCombinator), n(2);
            break;
          }
        } else if (Zt.test(t.slice(u)))
          S = r(0);
        else
          break e;
        t.charCodeAt(u) === 124 && t.charCodeAt(u + 1) !== 124 && (N = S, t.charCodeAt(u + 1) === 42 ? (S = "*", u += 2) : S = r(1)), a.push(S === "*" ? { type: A.Universal, namespace: N } : { type: A.Tag, name: S, namespace: N });
      }
    }
  }
  return I(), u;
}
var ve = {
  trueFunc: function() {
    return !0;
  },
  falseFunc: function() {
    return !1;
  }
};
const C = /* @__PURE__ */ Fa(ve), Wu = /* @__PURE__ */ new Map([
  [A.Universal, 50],
  [A.Tag, 30],
  [A.Attribute, 1],
  [A.Pseudo, 0]
]);
function Bt(e) {
  return !Wu.has(e.type);
}
const _r = /* @__PURE__ */ new Map([
  [P.Exists, 10],
  [P.Equals, 8],
  [P.Not, 7],
  [P.Start, 6],
  [P.End, 6],
  [P.Any, 5]
]);
function Ar(e) {
  const t = e.map(Qu);
  for (let u = 1; u < e.length; u++) {
    const a = t[u];
    if (!(a < 0))
      for (let r = u - 1; r >= 0 && a < t[r]; r--) {
        const n = e[r + 1];
        e[r + 1] = e[r], e[r] = n, t[r + 1] = t[r], t[r] = a;
      }
  }
}
function Qu(e) {
  var t, u;
  let a = (t = Wu.get(e.type)) !== null && t !== void 0 ? t : -1;
  return e.type === A.Attribute ? (a = (u = _r.get(e.action)) !== null && u !== void 0 ? u : 4, e.action === P.Equals && e.name === "id" && (a = 9), e.ignoreCase && (a >>= 1)) : e.type === A.Pseudo && (e.data ? e.name === "has" || e.name === "contains" ? a = 0 : Array.isArray(e.data) ? (a = Math.min(...e.data.map((r) => Math.min(...r.map(Qu)))), a < 0 && (a = 0)) : a = 2 : a = 3), a;
}
const pr = /[-[\]{}()*+?.,\\^$|#\s]/g;
function tu(e) {
  return e.replace(pr, "\\$&");
}
const gr = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "align",
  "alink",
  "axis",
  "bgcolor",
  "charset",
  "checked",
  "clear",
  "codetype",
  "color",
  "compact",
  "declare",
  "defer",
  "dir",
  "direction",
  "disabled",
  "enctype",
  "face",
  "frame",
  "hreflang",
  "http-equiv",
  "lang",
  "language",
  "link",
  "media",
  "method",
  "multiple",
  "nohref",
  "noresize",
  "noshade",
  "nowrap",
  "readonly",
  "rel",
  "rev",
  "rules",
  "scope",
  "scrolling",
  "selected",
  "shape",
  "target",
  "text",
  "type",
  "valign",
  "valuetype",
  "vlink"
]);
function $(e, t) {
  return typeof e.ignoreCase == "boolean" ? e.ignoreCase : e.ignoreCase === "quirks" ? !!t.quirksMode : !t.xmlMode && gr.has(e.name);
}
const Nr = {
  equals(e, t, u) {
    const { adapter: a } = u, { name: r } = t;
    let { value: n } = t;
    return $(t, u) ? (n = n.toLowerCase(), (c) => {
      const l = a.getAttributeValue(c, r);
      return l != null && l.length === n.length && l.toLowerCase() === n && e(c);
    }) : (c) => a.getAttributeValue(c, r) === n && e(c);
  },
  hyphen(e, t, u) {
    const { adapter: a } = u, { name: r } = t;
    let { value: n } = t;
    const c = n.length;
    return $(t, u) ? (n = n.toLowerCase(), function(h) {
      const T = a.getAttributeValue(h, r);
      return T != null && (T.length === c || T.charAt(c) === "-") && T.substr(0, c).toLowerCase() === n && e(h);
    }) : function(h) {
      const T = a.getAttributeValue(h, r);
      return T != null && (T.length === c || T.charAt(c) === "-") && T.substr(0, c) === n && e(h);
    };
  },
  element(e, t, u) {
    const { adapter: a } = u, { name: r, value: n } = t;
    if (/\s/.test(n))
      return C.falseFunc;
    const c = new RegExp(`(?:^|\\s)${tu(n)}(?:$|\\s)`, $(t, u) ? "i" : "");
    return function(h) {
      const T = a.getAttributeValue(h, r);
      return T != null && T.length >= n.length && c.test(T) && e(h);
    };
  },
  exists(e, { name: t }, { adapter: u }) {
    return (a) => u.hasAttrib(a, t) && e(a);
  },
  start(e, t, u) {
    const { adapter: a } = u, { name: r } = t;
    let { value: n } = t;
    const c = n.length;
    return c === 0 ? C.falseFunc : $(t, u) ? (n = n.toLowerCase(), (l) => {
      const h = a.getAttributeValue(l, r);
      return h != null && h.length >= c && h.substr(0, c).toLowerCase() === n && e(l);
    }) : (l) => {
      var h;
      return !!(!((h = a.getAttributeValue(l, r)) === null || h === void 0) && h.startsWith(n)) && e(l);
    };
  },
  end(e, t, u) {
    const { adapter: a } = u, { name: r } = t;
    let { value: n } = t;
    const c = -n.length;
    return c === 0 ? C.falseFunc : $(t, u) ? (n = n.toLowerCase(), (l) => {
      var h;
      return ((h = a.getAttributeValue(l, r)) === null || h === void 0 ? void 0 : h.substr(c).toLowerCase()) === n && e(l);
    }) : (l) => {
      var h;
      return !!(!((h = a.getAttributeValue(l, r)) === null || h === void 0) && h.endsWith(n)) && e(l);
    };
  },
  any(e, t, u) {
    const { adapter: a } = u, { name: r, value: n } = t;
    if (n === "")
      return C.falseFunc;
    if ($(t, u)) {
      const c = new RegExp(tu(n), "i");
      return function(h) {
        const T = a.getAttributeValue(h, r);
        return T != null && T.length >= n.length && c.test(T) && e(h);
      };
    }
    return (c) => {
      var l;
      return !!(!((l = a.getAttributeValue(c, r)) === null || l === void 0) && l.includes(n)) && e(c);
    };
  },
  not(e, t, u) {
    const { adapter: a } = u, { name: r } = t;
    let { value: n } = t;
    return n === "" ? (c) => !!a.getAttributeValue(c, r) && e(c) : $(t, u) ? (n = n.toLowerCase(), (c) => {
      const l = a.getAttributeValue(c, r);
      return (l == null || l.length !== n.length || l.toLowerCase() !== n) && e(c);
    }) : (c) => a.getAttributeValue(c, r) !== n && e(c);
  }
}, Cr = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]), uu = 48, Ir = 57;
function Sr(e) {
  if (e = e.trim().toLowerCase(), e === "even")
    return [2, 0];
  if (e === "odd")
    return [2, 1];
  let t = 0, u = 0, a = n(), r = c();
  if (t < e.length && e.charAt(t) === "n" && (t++, u = a * (r ?? 1), l(), t < e.length ? (a = n(), l(), r = c()) : a = r = 0), r === null || t < e.length)
    throw new Error(`n-th rule couldn't be parsed ('${e}')`);
  return [u, a * r];
  function n() {
    return e.charAt(t) === "-" ? (t++, -1) : (e.charAt(t) === "+" && t++, 1);
  }
  function c() {
    const h = t;
    let T = 0;
    for (; t < e.length && e.charCodeAt(t) >= uu && e.charCodeAt(t) <= Ir; )
      T = T * 10 + (e.charCodeAt(t) - uu), t++;
    return t === h ? null : T;
  }
  function l() {
    for (; t < e.length && Cr.has(e.charCodeAt(t)); )
      t++;
  }
}
function Or(e) {
  const t = e[0], u = e[1] - 1;
  if (u < 0 && t <= 0)
    return C.falseFunc;
  if (t === -1)
    return (n) => n <= u;
  if (t === 0)
    return (n) => n === u;
  if (t === 1)
    return u < 0 ? C.trueFunc : (n) => n >= u;
  const a = Math.abs(t), r = (u % a + a) % a;
  return t > 1 ? (n) => n >= u && n % a === r : (n) => n <= u && n % a === r;
}
function Pe(e) {
  return Or(Sr(e));
}
function Me(e, t) {
  return (u) => {
    const a = t.getParent(u);
    return a != null && t.isTag(a) && e(u);
  };
}
const mt = {
  contains(e, t, { adapter: u }) {
    return function(r) {
      return e(r) && u.getText(r).includes(t);
    };
  },
  icontains(e, t, { adapter: u }) {
    const a = t.toLowerCase();
    return function(n) {
      return e(n) && u.getText(n).toLowerCase().includes(a);
    };
  },
  // Location specific methods
  "nth-child"(e, t, { adapter: u, equals: a }) {
    const r = Pe(t);
    return r === C.falseFunc ? C.falseFunc : r === C.trueFunc ? Me(e, u) : function(c) {
      const l = u.getSiblings(c);
      let h = 0;
      for (let T = 0; T < l.length && !a(c, l[T]); T++)
        u.isTag(l[T]) && h++;
      return r(h) && e(c);
    };
  },
  "nth-last-child"(e, t, { adapter: u, equals: a }) {
    const r = Pe(t);
    return r === C.falseFunc ? C.falseFunc : r === C.trueFunc ? Me(e, u) : function(c) {
      const l = u.getSiblings(c);
      let h = 0;
      for (let T = l.length - 1; T >= 0 && !a(c, l[T]); T--)
        u.isTag(l[T]) && h++;
      return r(h) && e(c);
    };
  },
  "nth-of-type"(e, t, { adapter: u, equals: a }) {
    const r = Pe(t);
    return r === C.falseFunc ? C.falseFunc : r === C.trueFunc ? Me(e, u) : function(c) {
      const l = u.getSiblings(c);
      let h = 0;
      for (let T = 0; T < l.length; T++) {
        const _ = l[T];
        if (a(c, _))
          break;
        u.isTag(_) && u.getName(_) === u.getName(c) && h++;
      }
      return r(h) && e(c);
    };
  },
  "nth-last-of-type"(e, t, { adapter: u, equals: a }) {
    const r = Pe(t);
    return r === C.falseFunc ? C.falseFunc : r === C.trueFunc ? Me(e, u) : function(c) {
      const l = u.getSiblings(c);
      let h = 0;
      for (let T = l.length - 1; T >= 0; T--) {
        const _ = l[T];
        if (a(c, _))
          break;
        u.isTag(_) && u.getName(_) === u.getName(c) && h++;
      }
      return r(h) && e(c);
    };
  },
  // TODO determine the actual root element
  root(e, t, { adapter: u }) {
    return (a) => {
      const r = u.getParent(a);
      return (r == null || !u.isTag(r)) && e(a);
    };
  },
  scope(e, t, u, a) {
    const { equals: r } = u;
    return !a || a.length === 0 ? mt.root(e, t, u) : a.length === 1 ? (n) => r(a[0], n) && e(n) : (n) => a.includes(n) && e(n);
  },
  hover: ot("isHovered"),
  visited: ot("isVisited"),
  active: ot("isActive")
};
function ot(e) {
  return function(u, a, { adapter: r }) {
    const n = r[e];
    return typeof n != "function" ? C.falseFunc : function(l) {
      return n(l) && u(l);
    };
  };
}
const au = {
  empty(e, { adapter: t }) {
    return !t.getChildren(e).some((u) => (
      // FIXME: `getText` call is potentially expensive.
      t.isTag(u) || t.getText(u) !== ""
    ));
  },
  "first-child"(e, { adapter: t, equals: u }) {
    if (t.prevElementSibling)
      return t.prevElementSibling(e) == null;
    const a = t.getSiblings(e).find((r) => t.isTag(r));
    return a != null && u(e, a);
  },
  "last-child"(e, { adapter: t, equals: u }) {
    const a = t.getSiblings(e);
    for (let r = a.length - 1; r >= 0; r--) {
      if (u(e, a[r]))
        return !0;
      if (t.isTag(a[r]))
        break;
    }
    return !1;
  },
  "first-of-type"(e, { adapter: t, equals: u }) {
    const a = t.getSiblings(e), r = t.getName(e);
    for (let n = 0; n < a.length; n++) {
      const c = a[n];
      if (u(e, c))
        return !0;
      if (t.isTag(c) && t.getName(c) === r)
        break;
    }
    return !1;
  },
  "last-of-type"(e, { adapter: t, equals: u }) {
    const a = t.getSiblings(e), r = t.getName(e);
    for (let n = a.length - 1; n >= 0; n--) {
      const c = a[n];
      if (u(e, c))
        return !0;
      if (t.isTag(c) && t.getName(c) === r)
        break;
    }
    return !1;
  },
  "only-of-type"(e, { adapter: t, equals: u }) {
    const a = t.getName(e);
    return t.getSiblings(e).every((r) => u(e, r) || !t.isTag(r) || t.getName(r) !== a);
  },
  "only-child"(e, { adapter: t, equals: u }) {
    return t.getSiblings(e).every((a) => u(e, a) || !t.isTag(a));
  }
};
function su(e, t, u, a) {
  if (u === null) {
    if (e.length > a)
      throw new Error(`Pseudo-class :${t} requires an argument`);
  } else if (e.length === a)
    throw new Error(`Pseudo-class :${t} doesn't have any arguments`);
}
const Lr = {
  // Links
  "any-link": ":is(a, area, link)[href]",
  link: ":any-link:not(:visited)",
  // Forms
  // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
  disabled: `:is(
        :is(button, input, select, textarea, optgroup, option)[disabled],
        optgroup[disabled] > option,
        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)
    )`,
  enabled: ":not(:disabled)",
  checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
  required: ":is(input, select, textarea)[required]",
  optional: ":is(input, select, textarea):not([required])",
  // JQuery extensions
  // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
  selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
  checkbox: "[type=checkbox]",
  file: "[type=file]",
  password: "[type=password]",
  radio: "[type=radio]",
  reset: "[type=reset]",
  image: "[type=image]",
  submit: "[type=submit]",
  parent: ":not(:empty)",
  header: ":is(h1, h2, h3, h4, h5, h6)",
  button: ":is(button, input[type=button])",
  input: ":is(input, textarea, select, button)",
  text: "input:is(:not([type!='']), [type=text])"
}, Gu = {};
function Dr(e, t) {
  return e === C.falseFunc ? C.falseFunc : (u) => t.isTag(u) && e(u);
}
function Vu(e, t) {
  const u = t.getSiblings(e);
  if (u.length <= 1)
    return [];
  const a = u.indexOf(e);
  return a < 0 || a === u.length - 1 ? [] : u.slice(a + 1).filter(t.isTag);
}
function _t(e) {
  return {
    xmlMode: !!e.xmlMode,
    lowerCaseAttributeNames: !!e.lowerCaseAttributeNames,
    lowerCaseTags: !!e.lowerCaseTags,
    quirksMode: !!e.quirksMode,
    cacheResults: !!e.cacheResults,
    pseudos: e.pseudos,
    adapter: e.adapter,
    equals: e.equals
  };
}
const dt = (e, t, u, a, r) => {
  const n = r(t, _t(u), a);
  return n === C.trueFunc ? e : n === C.falseFunc ? C.falseFunc : (c) => n(c) && e(c);
}, lt = {
  is: dt,
  /**
   * `:matches` and `:where` are aliases for `:is`.
   */
  matches: dt,
  where: dt,
  not(e, t, u, a, r) {
    const n = r(t, _t(u), a);
    return n === C.falseFunc ? e : n === C.trueFunc ? C.falseFunc : (c) => !n(c) && e(c);
  },
  has(e, t, u, a, r) {
    const { adapter: n } = u, c = _t(u);
    c.relativeSelector = !0;
    const l = t.some((_) => _.some(Bt)) ? (
      // Used as a placeholder. Will be replaced with the actual element.
      [Gu]
    ) : void 0, h = r(t, c, l);
    if (h === C.falseFunc)
      return C.falseFunc;
    const T = Dr(h, n);
    if (l && h !== C.trueFunc) {
      const { shouldTestNextSiblings: _ = !1 } = h;
      return (I) => {
        if (!e(I))
          return !1;
        l[0] = I;
        const g = n.getChildren(I), N = _ ? [...g, ...Vu(I, n)] : g;
        return n.existsOne(T, N);
      };
    }
    return (_) => e(_) && n.existsOne(T, n.getChildren(_));
  }
};
function Rr(e, t, u, a, r) {
  var n;
  const { name: c, data: l } = t;
  if (Array.isArray(l)) {
    if (!(c in lt))
      throw new Error(`Unknown pseudo-class :${c}(${l})`);
    return lt[c](e, l, u, a, r);
  }
  const h = (n = u.pseudos) === null || n === void 0 ? void 0 : n[c], T = typeof h == "string" ? h : Lr[c];
  if (typeof T == "string") {
    if (l != null)
      throw new Error(`Pseudo ${c} doesn't have any arguments`);
    const _ = $e(T);
    return lt.is(e, _, u, a, r);
  }
  if (typeof h == "function")
    return su(h, c, l, 1), (_) => h(_, l) && e(_);
  if (c in mt)
    return mt[c](e, l, u, a);
  if (c in au) {
    const _ = au[c];
    return su(_, c, l, 2), (I) => _(I, u, l) && e(I);
  }
  throw new Error(`Unknown pseudo-class :${c}`);
}
function ft(e, t) {
  const u = t.getParent(e);
  return u && t.isTag(u) ? u : null;
}
function Pr(e, t, u, a, r) {
  const { adapter: n, equals: c } = u;
  switch (t.type) {
    case A.PseudoElement:
      throw new Error("Pseudo-elements are not supported by css-select");
    case A.ColumnCombinator:
      throw new Error("Column combinators are not yet supported by css-select");
    case A.Attribute: {
      if (t.namespace != null)
        throw new Error("Namespaced attributes are not yet supported by css-select");
      return (!u.xmlMode || u.lowerCaseAttributeNames) && (t.name = t.name.toLowerCase()), Nr[t.action](e, t, u);
    }
    case A.Pseudo:
      return Rr(e, t, u, a, r);
    case A.Tag: {
      if (t.namespace != null)
        throw new Error("Namespaced tag names are not yet supported by css-select");
      let { name: l } = t;
      return (!u.xmlMode || u.lowerCaseTags) && (l = l.toLowerCase()), function(T) {
        return n.getName(T) === l && e(T);
      };
    }
    case A.Descendant: {
      if (u.cacheResults === !1 || typeof WeakSet > "u")
        return function(T) {
          let _ = T;
          for (; _ = ft(_, n); )
            if (e(_))
              return !0;
          return !1;
        };
      const l = /* @__PURE__ */ new WeakSet();
      return function(T) {
        let _ = T;
        for (; _ = ft(_, n); )
          if (!l.has(_)) {
            if (n.isTag(_) && e(_))
              return !0;
            l.add(_);
          }
        return !1;
      };
    }
    case "_flexibleDescendant":
      return function(h) {
        let T = h;
        do
          if (e(T))
            return !0;
        while (T = ft(T, n));
        return !1;
      };
    case A.Parent:
      return function(h) {
        return n.getChildren(h).some((T) => n.isTag(T) && e(T));
      };
    case A.Child:
      return function(h) {
        const T = n.getParent(h);
        return T != null && n.isTag(T) && e(T);
      };
    case A.Sibling:
      return function(h) {
        const T = n.getSiblings(h);
        for (let _ = 0; _ < T.length; _++) {
          const I = T[_];
          if (c(h, I))
            break;
          if (n.isTag(I) && e(I))
            return !0;
        }
        return !1;
      };
    case A.Adjacent:
      return n.prevElementSibling ? function(h) {
        const T = n.prevElementSibling(h);
        return T != null && e(T);
      } : function(h) {
        const T = n.getSiblings(h);
        let _;
        for (let I = 0; I < T.length; I++) {
          const g = T[I];
          if (c(h, g))
            break;
          n.isTag(g) && (_ = g);
        }
        return !!_ && e(_);
      };
    case A.Universal: {
      if (t.namespace != null && t.namespace !== "*")
        throw new Error("Namespaced universal selectors are not yet supported by css-select");
      return e;
    }
  }
}
function Xu(e) {
  return e.type === A.Pseudo && (e.name === "scope" || Array.isArray(e.data) && e.data.some((t) => t.some(Xu)));
}
const Mr = { type: A.Descendant }, xr = {
  type: "_flexibleDescendant"
}, yr = {
  type: A.Pseudo,
  name: "scope",
  data: null
};
function Br(e, { adapter: t }, u) {
  const a = !!(u != null && u.every((r) => {
    const n = t.isTag(r) && t.getParent(r);
    return r === Gu || n && t.isTag(n);
  }));
  for (const r of e) {
    if (!(r.length > 0 && Bt(r[0]) && r[0].type !== A.Descendant)) if (a && !r.some(Xu))
      r.unshift(Mr);
    else
      continue;
    r.unshift(yr);
  }
}
function Ku(e, t, u) {
  var a;
  e.forEach(Ar), u = (a = t.context) !== null && a !== void 0 ? a : u;
  const r = Array.isArray(u), n = u && (Array.isArray(u) ? u : [u]);
  if (t.relativeSelector !== !1)
    Br(e, t, n);
  else if (e.some((h) => h.length > 0 && Bt(h[0])))
    throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
  let c = !1;
  const l = e.map((h) => {
    if (h.length >= 2) {
      const [T, _] = h;
      T.type !== A.Pseudo || T.name !== "scope" || (r && _.type === A.Descendant ? h[1] = xr : (_.type === A.Adjacent || _.type === A.Sibling) && (c = !0));
    }
    return kr(h, t, n);
  }).reduce(Fr, C.falseFunc);
  return l.shouldTestNextSiblings = c, l;
}
function kr(e, t, u) {
  var a;
  return e.reduce((r, n) => r === C.falseFunc ? C.falseFunc : Pr(r, n, t, u, Ku), (a = t.rootFunc) !== null && a !== void 0 ? a : C.trueFunc);
}
function Fr(e, t) {
  return t === C.falseFunc || e === C.trueFunc ? e : e === C.falseFunc || t === C.trueFunc ? t : function(a) {
    return e(a) || t(a);
  };
}
const ju = (e, t) => e === t, Ur = {
  adapter: je,
  equals: ju
};
function Hr(e) {
  var t, u, a, r;
  const n = e ?? Ur;
  return (t = n.adapter) !== null && t !== void 0 || (n.adapter = je), (u = n.equals) !== null && u !== void 0 || (n.equals = (r = (a = n.adapter) === null || a === void 0 ? void 0 : a.equals) !== null && r !== void 0 ? r : ju), n;
}
function wr(e) {
  return function(u, a, r) {
    const n = Hr(a);
    return e(u, n, r);
  };
}
const kt = wr(Ku);
function $u(e, t, u = !1) {
  return u && (e = vr(e, t)), Array.isArray(e) ? t.removeSubsets(e) : t.getChildren(e);
}
function vr(e, t) {
  const u = Array.isArray(e) ? e.slice(0) : [e], a = u.length;
  for (let r = 0; r < a; r++) {
    const n = Vu(u[r], t);
    u.push(...n);
  }
  return u;
}
const Yr = /* @__PURE__ */ new Set([
  "first",
  "last",
  "eq",
  "gt",
  "nth",
  "lt",
  "even",
  "odd"
]);
function Ye(e) {
  return e.type !== "pseudo" ? !1 : Yr.has(e.name) ? !0 : e.name === "not" && Array.isArray(e.data) ? e.data.some((t) => t.some(Ye)) : !1;
}
function qr(e, t, u) {
  const a = t != null ? parseInt(t, 10) : NaN;
  switch (e) {
    case "first":
      return 1;
    case "nth":
    case "eq":
      return isFinite(a) ? a >= 0 ? a + 1 : 1 / 0 : 0;
    case "lt":
      return isFinite(a) ? a >= 0 ? Math.min(a, u) : 1 / 0 : 0;
    case "gt":
      return isFinite(a) ? 1 / 0 : 0;
    case "odd":
      return 2 * u;
    case "even":
      return 2 * u - 1;
    case "last":
    case "not":
      return 1 / 0;
  }
}
function Wr(e) {
  for (; e.parent; )
    e = e.parent;
  return e;
}
function Ft(e) {
  const t = [], u = [];
  for (const a of e)
    a.some(Ye) ? t.push(a) : u.push(a);
  return [u, t];
}
const Qr = {
  type: A.Universal,
  namespace: null
}, Gr = {
  type: A.Pseudo,
  name: "scope",
  data: null
};
function zu(e, t, u = {}) {
  return Ju([e], t, u);
}
function Ju(e, t, u = {}) {
  if (typeof t == "function")
    return e.some(t);
  const [a, r] = Ft($e(t));
  return a.length > 0 && e.some(kt(a, u)) || r.some((n) => ta(n, e, u).length > 0);
}
function Vr(e, t, u, a) {
  const r = typeof u == "string" ? parseInt(u, 10) : NaN;
  switch (e) {
    case "first":
    case "lt":
      return t;
    case "last":
      return t.length > 0 ? [t[t.length - 1]] : t;
    case "nth":
    case "eq":
      return isFinite(r) && Math.abs(r) < t.length ? [r < 0 ? t[t.length + r] : t[r]] : [];
    case "gt":
      return isFinite(r) ? t.slice(r + 1) : [];
    case "even":
      return t.filter((n, c) => c % 2 === 0);
    case "odd":
      return t.filter((n, c) => c % 2 === 1);
    case "not": {
      const n = new Set(ea(u, t, a));
      return t.filter((c) => !n.has(c));
    }
  }
}
function Zu(e, t, u = {}) {
  return ea($e(e), t, u);
}
function ea(e, t, u) {
  if (t.length === 0)
    return [];
  const [a, r] = Ft(e);
  let n;
  if (a.length) {
    const c = pt(t, a, u);
    if (r.length === 0)
      return c;
    c.length && (n = new Set(c));
  }
  for (let c = 0; c < r.length && (n == null ? void 0 : n.size) !== t.length; c++) {
    const l = r[c];
    if ((n ? t.filter((_) => p(_) && !n.has(_)) : t).length === 0)
      break;
    const T = ta(l, t, u);
    if (T.length)
      if (n)
        T.forEach((_) => n.add(_));
      else {
        if (c === r.length - 1)
          return T;
        n = new Set(T);
      }
  }
  return typeof n < "u" ? n.size === t.length ? t : (
    // Filter elements to preserve order
    t.filter((c) => n.has(c))
  ) : [];
}
function ta(e, t, u) {
  var a;
  if (e.some(Te)) {
    const r = (a = u.root) !== null && a !== void 0 ? a : Wr(t[0]), n = { ...u, context: t, relativeSelector: !1 };
    return e.push(Gr), qe(r, e, n, !0, t.length);
  }
  return qe(t, e, u, !1, t.length);
}
function Xr(e, t, u = {}, a = 1 / 0) {
  if (typeof e == "function")
    return ua(t, e);
  const [r, n] = Ft($e(e)), c = n.map((l) => qe(t, l, u, !0, a));
  return r.length && c.push(At(t, r, u, a)), c.length === 0 ? [] : c.length === 1 ? c[0] : ce(c.reduce((l, h) => [...l, ...h]));
}
function qe(e, t, u, a, r) {
  const n = t.findIndex(Ye), c = t.slice(0, n), l = t[n], h = t.length - 1 === n ? r : 1 / 0, T = qr(l.name, l.data, h);
  if (T === 0)
    return [];
  const I = (c.length === 0 && !Array.isArray(e) ? Xe(e).filter(p) : c.length === 0 ? (Array.isArray(e) ? e : [e]).filter(p) : a || c.some(Te) ? At(e, [c], u, T) : pt(e, [c], u)).slice(0, T);
  let g = Vr(l.name, I, l.data, u);
  if (g.length === 0 || t.length === n + 1)
    return g;
  const N = t.slice(n + 1), S = N.some(Te);
  if (S) {
    if (Te(N[0])) {
      const { type: k } = N[0];
      (k === A.Sibling || k === A.Adjacent) && (g = $u(g, je, !0)), N.unshift(Qr);
    }
    u = {
      ...u,
      // Avoid absolutizing the selector
      relativeSelector: !1,
      /*
       * Add a custom root func, to make sure traversals don't match elements
       * that aren't a part of the considered tree.
       */
      rootFunc: (k) => g.includes(k)
    };
  } else u.rootFunc && u.rootFunc !== ve.trueFunc && (u = { ...u, rootFunc: ve.trueFunc });
  return N.some(Ye) ? qe(g, N, u, !1, r) : S ? (
    // Query existing elements to resolve traversal.
    At(g, [N], u, r)
  ) : (
    // If we don't have any more traversals, simply filter elements.
    pt(g, [N], u)
  );
}
function At(e, t, u, a) {
  const r = kt(t, u, e);
  return ua(e, r, a);
}
function ua(e, t, u = 1 / 0) {
  const a = $u(e, je, t.shouldTestNextSiblings);
  return Mt((r) => p(r) && t(r), a, !0, u);
}
function pt(e, t, u) {
  const a = (Array.isArray(e) ? e : [e]).filter(p);
  if (a.length === 0)
    return a;
  const r = kt(t, u);
  return r === ve.trueFunc ? a : a.filter(r);
}
const Kr = /^\s*[+~]/;
function jr(e) {
  if (!e)
    return this._make([]);
  if (typeof e != "string") {
    const t = oe(e) ? e.toArray() : [e], u = this.toArray();
    return this._make(t.filter((a) => u.some((r) => Fu(r, a))));
  }
  return this._findBySelector(e, Number.POSITIVE_INFINITY);
}
function $r(e, t) {
  var u;
  const a = this.toArray(), r = Kr.test(e) ? a : this.children().toArray(), n = {
    context: a,
    root: (u = this._root) === null || u === void 0 ? void 0 : u[0],
    // Pass options that are recognized by `cheerio-select`
    xmlMode: this.options.xmlMode,
    lowerCaseTags: this.options.lowerCaseTags,
    lowerCaseAttributeNames: this.options.lowerCaseAttributeNames,
    pseudos: this.options.pseudos,
    quirksMode: this.options.quirksMode
  };
  return this._make(Xr(e, r, n, t));
}
function Ut(e) {
  return function(t, ...u) {
    return function(a) {
      var r;
      let n = e(t, this);
      return a && (n = vt(n, a, this.options.xmlMode, (r = this._root) === null || r === void 0 ? void 0 : r[0])), this._make(
        // Post processing is only necessary if there is more than one element.
        this.length > 1 && n.length > 1 ? u.reduce((c, l) => l(c), n) : n
      );
    };
  };
}
const Oe = Ut((e, t) => {
  let u = [];
  for (let a = 0; a < t.length; a++) {
    const r = e(t[a]);
    r.length > 0 && (u = u.concat(r));
  }
  return u;
}), Ht = Ut((e, t) => {
  const u = [];
  for (let a = 0; a < t.length; a++) {
    const r = e(t[a]);
    r !== null && u.push(r);
  }
  return u;
});
function wt(e, ...t) {
  let u = null;
  const a = Ut((r, n) => {
    const c = [];
    return R(n, (l) => {
      for (let h; (h = r(l)) && !(u != null && u(h, c.length)); l = h)
        c.push(h);
    }), c;
  })(e, ...t);
  return function(r, n) {
    u = typeof r == "string" ? (l) => zu(l, r, this.options) : r ? Le(r) : null;
    const c = a.call(this, n);
    return u = null, c;
  };
}
function de(e) {
  return e.length > 1 ? Array.from(new Set(e)) : e;
}
const zr = Ht(({ parent: e }) => e && !te(e) ? e : null, de), Jr = Oe((e) => {
  const t = [];
  for (; e.parent && !te(e.parent); )
    t.push(e.parent), e = e.parent;
  return t;
}, ce, (e) => e.reverse()), Zr = wt(({ parent: e }) => e && !te(e) ? e : null, ce, (e) => e.reverse());
function en(e) {
  var t;
  const u = [];
  if (!e)
    return this._make(u);
  const a = {
    xmlMode: this.options.xmlMode,
    root: (t = this._root) === null || t === void 0 ? void 0 : t[0]
  }, r = typeof e == "string" ? (n) => zu(n, e, a) : Le(e);
  return R(this, (n) => {
    for (n && !te(n) && !p(n) && (n = n.parent); n && p(n); ) {
      if (r(n, 0)) {
        u.includes(n) || u.push(n);
        break;
      }
      n = n.parent;
    }
  }), this._make(u);
}
const tn = Ht((e) => Rt(e)), un = Oe((e) => {
  const t = [];
  for (; e.next; )
    e = e.next, p(e) && t.push(e);
  return t;
}, de), an = wt((e) => Rt(e), de), sn = Ht((e) => Pt(e)), rn = Oe((e) => {
  const t = [];
  for (; e.prev; )
    e = e.prev, p(e) && t.push(e);
  return t;
}, de), nn = wt((e) => Pt(e), de), cn = Oe((e) => Ru(e).filter((t) => p(t) && t !== e), ce), on = Oe((e) => Xe(e).filter(p), de);
function dn() {
  const e = this.toArray().reduce((t, u) => y(u) ? t.concat(u.children) : t, []);
  return this._make(e);
}
function ln(e) {
  let t = 0;
  const u = this.length;
  for (; t < u && e.call(this[t], t, this[t]) !== !1; )
    ++t;
  return this;
}
function fn(e) {
  let t = [];
  for (let u = 0; u < this.length; u++) {
    const a = this[u], r = e.call(a, u, a);
    r != null && (t = t.concat(r));
  }
  return this._make(t);
}
function Le(e) {
  return typeof e == "function" ? (t, u) => e.call(t, u, t) : oe(e) ? (t) => Array.prototype.includes.call(e, t) : function(t) {
    return e === t;
  };
}
function hn(e) {
  var t;
  return this._make(vt(this.toArray(), e, this.options.xmlMode, (t = this._root) === null || t === void 0 ? void 0 : t[0]));
}
function vt(e, t, u, a) {
  return typeof t == "string" ? Zu(t, e, { xmlMode: u, root: a }) : e.filter(Le(t));
}
function En(e) {
  const t = this.toArray();
  return typeof e == "string" ? Ju(t.filter(p), e, this.options) : e ? t.some(Le(e)) : !1;
}
function Tn(e) {
  let t = this.toArray();
  if (typeof e == "string") {
    const u = new Set(Zu(e, t, this.options));
    t = t.filter((a) => !u.has(a));
  } else {
    const u = Le(e);
    t = t.filter((a, r) => !u(a, r));
  }
  return this._make(t);
}
function bn(e) {
  return this.filter(typeof e == "string" ? (
    // Using the `:has` selector here short-circuits searches.
    `:has(${e})`
  ) : (t, u) => this._make(u).find(e).length > 0);
}
function mn() {
  return this.length > 1 ? this._make(this[0]) : this;
}
function _n() {
  return this.length > 0 ? this._make(this[this.length - 1]) : this;
}
function An(e) {
  var t;
  return e = +e, e === 0 && this.length <= 1 ? this : (e < 0 && (e = this.length + e), this._make((t = this[e]) !== null && t !== void 0 ? t : []));
}
function pn(e) {
  return e == null ? this.toArray() : this[e < 0 ? this.length + e : e];
}
function gn() {
  return Array.prototype.slice.call(this);
}
function Nn(e) {
  let t, u;
  return e == null ? (t = this.parent().children(), u = this[0]) : typeof e == "string" ? (t = this._make(e), u = this[0]) : (t = this, u = oe(e) ? e[0] : e), Array.prototype.indexOf.call(t, u);
}
function Cn(e, t) {
  return this._make(Array.prototype.slice.call(this, e, t));
}
function In() {
  var e;
  return (e = this.prevObject) !== null && e !== void 0 ? e : this._make([]);
}
function Sn(e, t) {
  const u = this._make(e, t), a = ce([...this.get(), ...u.get()]);
  return this._make(a);
}
function On(e) {
  return this.prevObject ? this.add(e ? this.prevObject.filter(e) : this.prevObject) : this;
}
const Ln = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _findBySelector: $r,
  add: Sn,
  addBack: On,
  children: on,
  closest: en,
  contents: dn,
  each: ln,
  end: In,
  eq: An,
  filter: hn,
  filterArray: vt,
  find: jr,
  first: mn,
  get: pn,
  has: bn,
  index: Nn,
  is: En,
  last: _n,
  map: fn,
  next: tn,
  nextAll: un,
  nextUntil: an,
  not: Tn,
  parent: zr,
  parents: Jr,
  parentsUntil: Zr,
  prev: sn,
  prevAll: rn,
  prevUntil: nn,
  siblings: cn,
  slice: Cn,
  toArray: gn
}, Symbol.toStringTag, { value: "Module" }));
function H0(e) {
  return function(u, a, r, n) {
    if (typeof Xt < "u" && Xt.isBuffer(u) && (u = u.toString()), typeof u == "string")
      return e(u, a, r, n);
    const c = u;
    if (!Array.isArray(c) && te(c))
      return c;
    const l = new Ot([]);
    return ee(c, l), l;
  };
}
function ee(e, t) {
  const u = Array.isArray(e) ? e : [e];
  t ? t.children = u : t = null;
  for (let a = 0; a < u.length; a++) {
    const r = u[a];
    r.parent && r.parent.children !== u && ue(r), t ? (r.prev = u[a - 1] || null, r.next = u[a + 1] || null) : r.prev = r.next = null, r.parent = t;
  }
  return t;
}
function Dn(e, t) {
  if (e == null)
    return [];
  if (typeof e == "string")
    return this._parse(e, this.options, !1, null).children.slice(0);
  if ("length" in e) {
    if (e.length === 1)
      return this._makeDomArray(e[0], t);
    const u = [];
    for (let a = 0; a < e.length; a++) {
      const r = e[a];
      if (typeof r == "object") {
        if (r == null)
          continue;
        if (!("length" in r)) {
          u.push(t ? ge(r, !0) : r);
          continue;
        }
      }
      u.push(...this._makeDomArray(r, t));
    }
    return u;
  }
  return [t ? ge(e, !0) : e];
}
function aa(e) {
  return function(...t) {
    const u = this.length - 1;
    return R(this, (a, r) => {
      if (!y(a))
        return;
      const n = typeof t[0] == "function" ? t[0].call(a, r, this._render(a.children)) : t, c = this._makeDomArray(n, r < u);
      e(c, a.children, a);
    });
  };
}
function K(e, t, u, a, r) {
  var n, c;
  const l = [
    t,
    u,
    ...a
  ], h = t === 0 ? null : e[t - 1], T = t + u >= e.length ? null : e[t + u];
  for (let _ = 0; _ < a.length; ++_) {
    const I = a[_], g = I.parent;
    if (g) {
      const S = g.children.indexOf(I);
      S > -1 && (g.children.splice(S, 1), r === g && t > S && l[0]--);
    }
    I.parent = r, I.prev && (I.prev.next = (n = I.next) !== null && n !== void 0 ? n : null), I.next && (I.next.prev = (c = I.prev) !== null && c !== void 0 ? c : null), I.prev = _ === 0 ? h : a[_ - 1], I.next = _ === a.length - 1 ? T : a[_ + 1];
  }
  return h && (h.next = a[0]), T && (T.prev = a[a.length - 1]), e.splice(...l);
}
function Rn(e) {
  return (oe(e) ? e : this._make(e)).append(this), this;
}
function Pn(e) {
  return (oe(e) ? e : this._make(e)).prepend(this), this;
}
const Mn = aa((e, t, u) => {
  K(t, t.length, 0, e, u);
}), xn = aa((e, t, u) => {
  K(t, 0, 0, e, u);
});
function sa(e) {
  return function(t) {
    const u = this.length - 1, a = this.parents().last();
    for (let r = 0; r < this.length; r++) {
      const n = this[r], c = typeof t == "function" ? t.call(n, r, n) : typeof t == "string" && !ur(t) ? a.find(t).clone() : t, [l] = this._makeDomArray(c, r < u);
      if (!l || !y(l))
        continue;
      let h = l, T = 0;
      for (; T < h.children.length; ) {
        const _ = h.children[T];
        p(_) ? (h = _, T = 0) : T++;
      }
      e(n, h, [l]);
    }
    return this;
  };
}
const yn = sa((e, t, u) => {
  const { parent: a } = e;
  if (!a)
    return;
  const r = a.children, n = r.indexOf(e);
  ee([e], t), K(r, n, 0, u, a);
}), Bn = sa((e, t, u) => {
  y(e) && (ee(e.children, t), ee(u, e));
});
function kn(e) {
  return this.parent(e).not("body").each((t, u) => {
    this._make(u).replaceWith(u.children);
  }), this;
}
function Fn(e) {
  const t = this[0];
  if (t) {
    const u = this._make(typeof e == "function" ? e.call(t, 0, t) : e).insertBefore(t);
    let a;
    for (let n = 0; n < u.length; n++)
      u[n].type === "tag" && (a = u[n]);
    let r = 0;
    for (; a && r < a.children.length; ) {
      const n = a.children[r];
      n.type === "tag" ? (a = n, r = 0) : r++;
    }
    a && this._make(a).append(this);
  }
  return this;
}
function Un(...e) {
  const t = this.length - 1;
  return R(this, (u, a) => {
    if (!y(u) || !u.parent)
      return;
    const r = u.parent.children, n = r.indexOf(u);
    if (n < 0)
      return;
    const c = typeof e[0] == "function" ? e[0].call(u, a, this._render(u.children)) : e, l = this._makeDomArray(c, a < t);
    K(r, n + 1, 0, l, u.parent);
  });
}
function Hn(e) {
  typeof e == "string" && (e = this._make(e)), this.remove();
  const t = [];
  for (const u of this._makeDomArray(e)) {
    const a = this.clone().toArray(), { parent: r } = u;
    if (!r)
      continue;
    const n = r.children, c = n.indexOf(u);
    c < 0 || (K(n, c + 1, 0, a, r), t.push(...a));
  }
  return this._make(t);
}
function wn(...e) {
  const t = this.length - 1;
  return R(this, (u, a) => {
    if (!y(u) || !u.parent)
      return;
    const r = u.parent.children, n = r.indexOf(u);
    if (n < 0)
      return;
    const c = typeof e[0] == "function" ? e[0].call(u, a, this._render(u.children)) : e, l = this._makeDomArray(c, a < t);
    K(r, n, 0, l, u.parent);
  });
}
function vn(e) {
  const t = this._make(e);
  this.remove();
  const u = [];
  return R(t, (a) => {
    const r = this.clone().toArray(), { parent: n } = a;
    if (!n)
      return;
    const c = n.children, l = c.indexOf(a);
    l < 0 || (K(c, l, 0, r, n), u.push(...r));
  }), this._make(u);
}
function Yn(e) {
  const t = e ? this.filter(e) : this;
  return R(t, (u) => {
    ue(u), u.prev = u.next = u.parent = null;
  }), this;
}
function qn(e) {
  return R(this, (t, u) => {
    const { parent: a } = t;
    if (!a)
      return;
    const r = a.children, n = typeof e == "function" ? e.call(t, u, t) : e, c = this._makeDomArray(n);
    ee(c, null);
    const l = r.indexOf(t);
    K(r, l, 1, c, a), c.includes(t) || (t.parent = t.prev = t.next = null);
  });
}
function Wn() {
  return R(this, (e) => {
    if (y(e)) {
      for (const t of e.children)
        t.next = t.prev = t.parent = null;
      e.children.length = 0;
    }
  });
}
function Qn(e) {
  if (e === void 0) {
    const t = this[0];
    return !t || !y(t) ? null : this._render(t.children);
  }
  return R(this, (t) => {
    if (!y(t))
      return;
    for (const a of t.children)
      a.next = a.prev = a.parent = null;
    const u = oe(e) ? e.toArray() : this._parse(`${e}`, this.options, !1, t).children;
    ee(u, t);
  });
}
function Gn() {
  return this._render(this);
}
function Vn(e) {
  return e === void 0 ? Ne(this) : typeof e == "function" ? R(this, (t, u) => this._make(t).text(e.call(t, u, Ne([t])))) : R(this, (t) => {
    if (!y(t))
      return;
    for (const a of t.children)
      a.next = a.prev = a.parent = null;
    const u = new Au(`${e}`);
    ee(u, t);
  });
}
function Xn() {
  const e = Array.prototype.map.call(this.get(), (u) => ge(u, !0)), t = new Ot(e);
  for (const u of e)
    u.parent = t;
  return this._make(e);
}
const Kn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _makeDomArray: Dn,
  after: Un,
  append: Mn,
  appendTo: Rn,
  before: wn,
  clone: Xn,
  empty: Wn,
  html: Qn,
  insertAfter: Hn,
  insertBefore: vn,
  prepend: xn,
  prependTo: Pn,
  remove: Yn,
  replaceWith: qn,
  text: Vn,
  toString: Gn,
  unwrap: kn,
  wrap: yn,
  wrapAll: Fn,
  wrapInner: Bn
}, Symbol.toStringTag, { value: "Module" }));
function jn(e, t) {
  if (e != null && t != null || // When `prop` is a "plain" object
  typeof e == "object" && !Array.isArray(e))
    return R(this, (u, a) => {
      p(u) && ra(u, e, t, a);
    });
  if (this.length !== 0)
    return na(this[0], e);
}
function ra(e, t, u, a) {
  if (typeof t == "string") {
    const r = na(e), n = typeof u == "function" ? u.call(e, a, r[t]) : u;
    n === "" ? delete r[t] : n != null && (r[t] = n), e.attribs.style = $n(r);
  } else if (typeof t == "object") {
    const r = Object.keys(t);
    for (let n = 0; n < r.length; n++) {
      const c = r[n];
      ra(e, c, t[c], n);
    }
  }
}
function na(e, t) {
  if (!e || !p(e))
    return;
  const u = zn(e.attribs.style);
  if (typeof t == "string")
    return u[t];
  if (Array.isArray(t)) {
    const a = {};
    for (const r of t)
      u[r] != null && (a[r] = u[r]);
    return a;
  }
  return u;
}
function $n(e) {
  return Object.keys(e).reduce((t, u) => `${t}${t ? " " : ""}${u}: ${e[u]};`, "");
}
function zn(e) {
  if (e = (e || "").trim(), !e)
    return {};
  const t = {};
  let u;
  for (const a of e.split(";")) {
    const r = a.indexOf(":");
    if (r < 1 || r === a.length - 1) {
      const n = a.trimEnd();
      n.length > 0 && u !== void 0 && (t[u] += `;${n}`);
    } else
      u = a.slice(0, r).trim(), t[u] = a.slice(r + 1).trim();
  }
  return t;
}
const Jn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  css: jn
}, Symbol.toStringTag, { value: "Module" })), ru = "input,select,textarea,keygen", Zn = /%20/g, nu = /\r?\n/g;
function ei() {
  return this.serializeArray().map((u) => `${encodeURIComponent(u.name)}=${encodeURIComponent(u.value)}`).join("&").replace(Zn, "+");
}
function ti() {
  return this.map((e, t) => {
    const u = this._make(t);
    return p(t) && t.name === "form" ? u.find(ru).toArray() : u.filter(ru).toArray();
  }).filter(
    // Verify elements have a name (`attr.name`) and are not disabled (`:enabled`)
    '[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))'
  ).map((e, t) => {
    var u;
    const a = this._make(t), r = a.attr("name"), n = (u = a.val()) !== null && u !== void 0 ? u : "";
    return Array.isArray(n) ? n.map((c) => (
      /*
       * We trim replace any line endings (e.g. `\r` or `\r\n` with `\r\n`) to guarantee consistency across platforms
       * These can occur inside of `<textarea>'s`
       */
      { name: r, value: c.replace(nu, `\r
`) }
    )) : { name: r, value: n.replace(nu, `\r
`) };
  }).toArray();
}
const ui = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  serialize: ei,
  serializeArray: ti
}, Symbol.toStringTag, { value: "Module" }));
function ai(e) {
  var t;
  return typeof e == "string" ? { selector: e, value: "textContent" } : {
    selector: e.selector,
    value: (t = e.value) !== null && t !== void 0 ? t : "textContent"
  };
}
function si(e) {
  const t = {};
  for (const u in e) {
    const a = e[u], r = Array.isArray(a), { selector: n, value: c } = ai(r ? a[0] : a), l = typeof c == "function" ? c : typeof c == "string" ? (h) => this._make(h).prop(c) : (h) => this._make(h).extract(c);
    if (r)
      t[u] = this._findBySelector(n, Number.POSITIVE_INFINITY).map((h, T) => l(T, u, t)).get();
    else {
      const h = this._findBySelector(n, 1);
      t[u] = h.length > 0 ? l(h[0], u, t) : void 0;
    }
  }
  return t;
}
const ri = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  extract: si
}, Symbol.toStringTag, { value: "Module" }));
class ze {
  /**
   * Instance of cheerio. Methods are specified in the modules. Usage of this
   * constructor is not recommended. Please use `$.load` instead.
   *
   * @private
   * @param elements - The new selection.
   * @param root - Sets the root node.
   * @param options - Options for the instance.
   */
  constructor(t, u, a) {
    if (this.length = 0, this.options = a, this._root = u, t) {
      for (let r = 0; r < t.length; r++)
        this[r] = t[r];
      this.length = t.length;
    }
  }
}
ze.prototype.cheerio = "[cheerio object]";
ze.prototype.splice = Array.prototype.splice;
ze.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
Object.assign(ze.prototype, fr, Ln, Kn, Jn, ui, ri);
const ni = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), D = "�";
var i;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(i || (i = {}));
const F = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function ia(e) {
  return e >= 55296 && e <= 57343;
}
function ii(e) {
  return e >= 56320 && e <= 57343;
}
function ci(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function ca(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function oa(e) {
  return e >= 64976 && e <= 65007 || ni.has(e);
}
var E;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(E || (E = {}));
const oi = 65536;
class di {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = oi, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, u) {
    const { line: a, col: r, offset: n } = this, c = r + u, l = n + u;
    return {
      code: t,
      startLine: a,
      endLine: a,
      startCol: c,
      endCol: c,
      startOffset: l,
      endOffset: l
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const u = this.html.charCodeAt(this.pos + 1);
      if (ii(u))
        return this.pos++, this._addGap(), ci(t, u);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, i.EOF;
    return this._err(E.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, u) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = u;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, u) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (u)
      return this.html.startsWith(t, this.pos);
    for (let a = 0; a < t.length; a++)
      if ((this.html.charCodeAt(this.pos + a) | 32) !== t.charCodeAt(a))
        return !1;
    return !0;
  }
  peek(t) {
    const u = this.pos + t;
    if (u >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, i.EOF;
    const a = this.html.charCodeAt(u);
    return a === i.CARRIAGE_RETURN ? i.LINE_FEED : a;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, i.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === i.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, i.LINE_FEED) : t === i.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, ia(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === i.LINE_FEED || t === i.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    ca(t) ? this._err(E.controlCharacterInInputStream) : oa(t) && this._err(E.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var O;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(O || (O = {}));
function da(e, t) {
  for (let u = e.attrs.length - 1; u >= 0; u--)
    if (e.attrs[u].name === t)
      return e.attrs[u].value;
  return null;
}
var b;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(b || (b = {}));
var J;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(J || (J = {}));
var v;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(v || (v = {}));
var f;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(f || (f = {}));
var s;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(s || (s = {}));
const li = /* @__PURE__ */ new Map([
  [f.A, s.A],
  [f.ADDRESS, s.ADDRESS],
  [f.ANNOTATION_XML, s.ANNOTATION_XML],
  [f.APPLET, s.APPLET],
  [f.AREA, s.AREA],
  [f.ARTICLE, s.ARTICLE],
  [f.ASIDE, s.ASIDE],
  [f.B, s.B],
  [f.BASE, s.BASE],
  [f.BASEFONT, s.BASEFONT],
  [f.BGSOUND, s.BGSOUND],
  [f.BIG, s.BIG],
  [f.BLOCKQUOTE, s.BLOCKQUOTE],
  [f.BODY, s.BODY],
  [f.BR, s.BR],
  [f.BUTTON, s.BUTTON],
  [f.CAPTION, s.CAPTION],
  [f.CENTER, s.CENTER],
  [f.CODE, s.CODE],
  [f.COL, s.COL],
  [f.COLGROUP, s.COLGROUP],
  [f.DD, s.DD],
  [f.DESC, s.DESC],
  [f.DETAILS, s.DETAILS],
  [f.DIALOG, s.DIALOG],
  [f.DIR, s.DIR],
  [f.DIV, s.DIV],
  [f.DL, s.DL],
  [f.DT, s.DT],
  [f.EM, s.EM],
  [f.EMBED, s.EMBED],
  [f.FIELDSET, s.FIELDSET],
  [f.FIGCAPTION, s.FIGCAPTION],
  [f.FIGURE, s.FIGURE],
  [f.FONT, s.FONT],
  [f.FOOTER, s.FOOTER],
  [f.FOREIGN_OBJECT, s.FOREIGN_OBJECT],
  [f.FORM, s.FORM],
  [f.FRAME, s.FRAME],
  [f.FRAMESET, s.FRAMESET],
  [f.H1, s.H1],
  [f.H2, s.H2],
  [f.H3, s.H3],
  [f.H4, s.H4],
  [f.H5, s.H5],
  [f.H6, s.H6],
  [f.HEAD, s.HEAD],
  [f.HEADER, s.HEADER],
  [f.HGROUP, s.HGROUP],
  [f.HR, s.HR],
  [f.HTML, s.HTML],
  [f.I, s.I],
  [f.IMG, s.IMG],
  [f.IMAGE, s.IMAGE],
  [f.INPUT, s.INPUT],
  [f.IFRAME, s.IFRAME],
  [f.KEYGEN, s.KEYGEN],
  [f.LABEL, s.LABEL],
  [f.LI, s.LI],
  [f.LINK, s.LINK],
  [f.LISTING, s.LISTING],
  [f.MAIN, s.MAIN],
  [f.MALIGNMARK, s.MALIGNMARK],
  [f.MARQUEE, s.MARQUEE],
  [f.MATH, s.MATH],
  [f.MENU, s.MENU],
  [f.META, s.META],
  [f.MGLYPH, s.MGLYPH],
  [f.MI, s.MI],
  [f.MO, s.MO],
  [f.MN, s.MN],
  [f.MS, s.MS],
  [f.MTEXT, s.MTEXT],
  [f.NAV, s.NAV],
  [f.NOBR, s.NOBR],
  [f.NOFRAMES, s.NOFRAMES],
  [f.NOEMBED, s.NOEMBED],
  [f.NOSCRIPT, s.NOSCRIPT],
  [f.OBJECT, s.OBJECT],
  [f.OL, s.OL],
  [f.OPTGROUP, s.OPTGROUP],
  [f.OPTION, s.OPTION],
  [f.P, s.P],
  [f.PARAM, s.PARAM],
  [f.PLAINTEXT, s.PLAINTEXT],
  [f.PRE, s.PRE],
  [f.RB, s.RB],
  [f.RP, s.RP],
  [f.RT, s.RT],
  [f.RTC, s.RTC],
  [f.RUBY, s.RUBY],
  [f.S, s.S],
  [f.SCRIPT, s.SCRIPT],
  [f.SEARCH, s.SEARCH],
  [f.SECTION, s.SECTION],
  [f.SELECT, s.SELECT],
  [f.SOURCE, s.SOURCE],
  [f.SMALL, s.SMALL],
  [f.SPAN, s.SPAN],
  [f.STRIKE, s.STRIKE],
  [f.STRONG, s.STRONG],
  [f.STYLE, s.STYLE],
  [f.SUB, s.SUB],
  [f.SUMMARY, s.SUMMARY],
  [f.SUP, s.SUP],
  [f.TABLE, s.TABLE],
  [f.TBODY, s.TBODY],
  [f.TEMPLATE, s.TEMPLATE],
  [f.TEXTAREA, s.TEXTAREA],
  [f.TFOOT, s.TFOOT],
  [f.TD, s.TD],
  [f.TH, s.TH],
  [f.THEAD, s.THEAD],
  [f.TITLE, s.TITLE],
  [f.TR, s.TR],
  [f.TRACK, s.TRACK],
  [f.TT, s.TT],
  [f.U, s.U],
  [f.UL, s.UL],
  [f.SVG, s.SVG],
  [f.VAR, s.VAR],
  [f.WBR, s.WBR],
  [f.XMP, s.XMP]
]);
function Je(e) {
  var t;
  return (t = li.get(e)) !== null && t !== void 0 ? t : s.UNKNOWN;
}
const m = s, fi = {
  [b.HTML]: /* @__PURE__ */ new Set([
    m.ADDRESS,
    m.APPLET,
    m.AREA,
    m.ARTICLE,
    m.ASIDE,
    m.BASE,
    m.BASEFONT,
    m.BGSOUND,
    m.BLOCKQUOTE,
    m.BODY,
    m.BR,
    m.BUTTON,
    m.CAPTION,
    m.CENTER,
    m.COL,
    m.COLGROUP,
    m.DD,
    m.DETAILS,
    m.DIR,
    m.DIV,
    m.DL,
    m.DT,
    m.EMBED,
    m.FIELDSET,
    m.FIGCAPTION,
    m.FIGURE,
    m.FOOTER,
    m.FORM,
    m.FRAME,
    m.FRAMESET,
    m.H1,
    m.H2,
    m.H3,
    m.H4,
    m.H5,
    m.H6,
    m.HEAD,
    m.HEADER,
    m.HGROUP,
    m.HR,
    m.HTML,
    m.IFRAME,
    m.IMG,
    m.INPUT,
    m.LI,
    m.LINK,
    m.LISTING,
    m.MAIN,
    m.MARQUEE,
    m.MENU,
    m.META,
    m.NAV,
    m.NOEMBED,
    m.NOFRAMES,
    m.NOSCRIPT,
    m.OBJECT,
    m.OL,
    m.P,
    m.PARAM,
    m.PLAINTEXT,
    m.PRE,
    m.SCRIPT,
    m.SECTION,
    m.SELECT,
    m.SOURCE,
    m.STYLE,
    m.SUMMARY,
    m.TABLE,
    m.TBODY,
    m.TD,
    m.TEMPLATE,
    m.TEXTAREA,
    m.TFOOT,
    m.TH,
    m.THEAD,
    m.TITLE,
    m.TR,
    m.TRACK,
    m.UL,
    m.WBR,
    m.XMP
  ]),
  [b.MATHML]: /* @__PURE__ */ new Set([m.MI, m.MO, m.MN, m.MS, m.MTEXT, m.ANNOTATION_XML]),
  [b.SVG]: /* @__PURE__ */ new Set([m.TITLE, m.FOREIGN_OBJECT, m.DESC]),
  [b.XLINK]: /* @__PURE__ */ new Set(),
  [b.XML]: /* @__PURE__ */ new Set(),
  [b.XMLNS]: /* @__PURE__ */ new Set()
}, gt = /* @__PURE__ */ new Set([m.H1, m.H2, m.H3, m.H4, m.H5, m.H6]), hi = /* @__PURE__ */ new Set([
  f.STYLE,
  f.SCRIPT,
  f.XMP,
  f.IFRAME,
  f.NOEMBED,
  f.NOFRAMES,
  f.PLAINTEXT
]);
function Ei(e, t) {
  return hi.has(e) || t && e === f.NOSCRIPT;
}
var o;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(o || (o = {}));
const H = {
  DATA: o.DATA,
  RCDATA: o.RCDATA,
  RAWTEXT: o.RAWTEXT,
  SCRIPT_DATA: o.SCRIPT_DATA,
  PLAINTEXT: o.PLAINTEXT,
  CDATA_SECTION: o.CDATA_SECTION
};
function Ti(e) {
  return e >= i.DIGIT_0 && e <= i.DIGIT_9;
}
function Ee(e) {
  return e >= i.LATIN_CAPITAL_A && e <= i.LATIN_CAPITAL_Z;
}
function bi(e) {
  return e >= i.LATIN_SMALL_A && e <= i.LATIN_SMALL_Z;
}
function G(e) {
  return bi(e) || Ee(e);
}
function iu(e) {
  return G(e) || Ti(e);
}
function xe(e) {
  return e + 32;
}
function la(e) {
  return e === i.SPACE || e === i.LINE_FEED || e === i.TABULATION || e === i.FORM_FEED;
}
function cu(e) {
  return la(e) || e === i.SOLIDUS || e === i.GREATER_THAN_SIGN;
}
function mi(e) {
  return e === i.NULL ? E.nullCharacterReference : e > 1114111 ? E.characterReferenceOutsideUnicodeRange : ia(e) ? E.surrogateCharacterReference : oa(e) ? E.noncharacterCharacterReference : ca(e) || e === i.CARRIAGE_RETURN ? E.controlCharacterReference : null;
}
class _i {
  constructor(t, u) {
    this.options = t, this.handler = u, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = o.DATA, this.returnState = o.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new di(u), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new gu(pu, (a, r) => {
      this.preprocessor.pos = this.entityStartPos + r - 1, this._flushCodePointConsumedAsCharacterReference(a);
    }, u.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(E.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (a) => {
        this._err(E.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + a);
      },
      validateNumericCharacterReference: (a) => {
        const r = mi(a);
        r && this._err(r, 1);
      }
    } : void 0);
  }
  //Errors
  _err(t, u = 0) {
    var a, r;
    (r = (a = this.handler).onParseError) === null || r === void 0 || r.call(a, this.preprocessor.getError(t, u));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t == null || t());
  }
  write(t, u, a) {
    this.active = !0, this.preprocessor.write(t, u), this._runParsingLoop(), this.paused || a == null || a();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let u = 0; u < t; u++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, u) {
    return this.preprocessor.startsWith(t, u) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: O.START_TAG,
      tagName: "",
      tagID: s.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: O.END_TAG,
      tagName: "",
      tagID: s.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: O.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: O.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, u) {
    this.currentCharacterToken = {
      type: t,
      chars: u,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, u;
    const a = this.currentToken;
    if (da(a, this.currentAttr.name) === null) {
      if (a.attrs.push(this.currentAttr), a.location && this.currentLocation) {
        const r = (t = (u = a.location).attrs) !== null && t !== void 0 ? t : u.attrs = /* @__PURE__ */ Object.create(null);
        r[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(E.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = Je(t.tagName), t.type === O.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(E.endTagWithAttributes), t.selfClosing && this._err(E.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case O.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case O.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case O.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: O.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, u) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += u;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(t, u);
  }
  _emitCodePoint(t) {
    const u = la(t) ? O.WHITESPACE_CHARACTER : t === i.NULL ? O.NULL_CHARACTER : O.CHARACTER;
    this._appendCharToCurrentCharacterToken(u, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(O.CHARACTER, t);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = o.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? Q.Attribute : Q.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === o.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === o.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === o.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case o.DATA: {
        this._stateData(t);
        break;
      }
      case o.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case o.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case o.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case o.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case o.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case o.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case o.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case o.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case o.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case o.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case o.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case o.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case o.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case o.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case o.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case o.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case o.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case o.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case o.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case o.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case o.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case o.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case o.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case o.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case o.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case o.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case o.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case o.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case o.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case o.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case o.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case o.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case o.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case o.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case o.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case o.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case o.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case o.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case o.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case o.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case o.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case o.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case o.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case o.COMMENT: {
        this._stateComment(t);
        break;
      }
      case o.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case o.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case o.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case o.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case o.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case o.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case o.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case o.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case o.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case o.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case o.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case o.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case o.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case o.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case o.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case o.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case o.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case o.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case o.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case o.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case o.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case o.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case o.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case o.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case o.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case o.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case o.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case o.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case i.LESS_THAN_SIGN: {
        this.state = o.TAG_OPEN;
        break;
      }
      case i.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case i.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case i.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case i.LESS_THAN_SIGN: {
        this.state = o.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case i.LESS_THAN_SIGN: {
        this.state = o.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case i.LESS_THAN_SIGN: {
        this.state = o.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (G(t))
      this._createStartTagToken(), this.state = o.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case i.EXCLAMATION_MARK: {
          this.state = o.MARKUP_DECLARATION_OPEN;
          break;
        }
        case i.SOLIDUS: {
          this.state = o.END_TAG_OPEN;
          break;
        }
        case i.QUESTION_MARK: {
          this._err(E.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = o.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case i.EOF: {
          this._err(E.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(E.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = o.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (G(t))
      this._createEndTagToken(), this.state = o.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case i.GREATER_THAN_SIGN: {
          this._err(E.missingEndTagName), this.state = o.DATA;
          break;
        }
        case i.EOF: {
          this._err(E.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(E.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = o.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED: {
        this.state = o.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case i.SOLIDUS: {
        this.state = o.SELF_CLOSING_START_TAG;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this.state = o.DATA, this.emitCurrentTagToken();
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), u.tagName += D;
        break;
      }
      case i.EOF: {
        this._err(E.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        u.tagName += String.fromCodePoint(Ee(t) ? xe(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === i.SOLIDUS ? this.state = o.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = o.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    G(t) ? (this.state = o.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = o.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const u = this.currentToken;
    switch (u.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = o.BEFORE_ATTRIBUTE_NAME, !1;
      case i.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = o.SELF_CLOSING_START_TAG, !1;
      case i.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = o.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = o.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === i.SOLIDUS ? this.state = o.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = o.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    G(t) ? (this.state = o.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = o.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = o.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case i.SOLIDUS: {
        this.state = o.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case i.EXCLAMATION_MARK: {
        this.state = o.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = o.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    G(t) ? (this.state = o.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = o.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = o.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === i.HYPHEN_MINUS ? (this.state = o.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = o.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === i.HYPHEN_MINUS ? (this.state = o.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = o.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case i.HYPHEN_MINUS: {
        this.state = o.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case i.LESS_THAN_SIGN: {
        this.state = o.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._err(E.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case i.HYPHEN_MINUS: {
        this.state = o.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case i.LESS_THAN_SIGN: {
        this.state = o.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this.state = o.SCRIPT_DATA_ESCAPED, this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._err(E.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = o.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case i.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case i.LESS_THAN_SIGN: {
        this.state = o.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this.state = o.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this.state = o.SCRIPT_DATA_ESCAPED, this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._err(E.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = o.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === i.SOLIDUS ? this.state = o.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : G(t) ? (this._emitChars("<"), this.state = o.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = o.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    G(t) ? (this.state = o.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = o.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = o.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(F.SCRIPT, !1) && cu(this.preprocessor.peek(F.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let u = 0; u < F.SCRIPT.length; u++)
        this._emitCodePoint(this._consume());
      this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = o.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case i.HYPHEN_MINUS: {
        this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case i.LESS_THAN_SIGN: {
        this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._err(E.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case i.HYPHEN_MINUS: {
        this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case i.LESS_THAN_SIGN: {
        this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._err(E.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case i.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case i.LESS_THAN_SIGN: {
        this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this.state = o.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(D);
        break;
      }
      case i.EOF: {
        this._err(E.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === i.SOLIDUS ? (this.state = o.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(F.SCRIPT, !1) && cu(this.preprocessor.peek(F.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let u = 0; u < F.SCRIPT.length; u++)
        this._emitCodePoint(this._consume());
      this.state = o.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = o.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
        break;
      case i.SOLIDUS:
      case i.GREATER_THAN_SIGN:
      case i.EOF: {
        this.state = o.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case i.EQUALS_SIGN: {
        this._err(E.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = o.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = o.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
      case i.SOLIDUS:
      case i.GREATER_THAN_SIGN:
      case i.EOF: {
        this._leaveAttrName(), this.state = o.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case i.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = o.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case i.QUOTATION_MARK:
      case i.APOSTROPHE:
      case i.LESS_THAN_SIGN: {
        this._err(E.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this.currentAttr.name += D;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Ee(t) ? xe(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
        break;
      case i.SOLIDUS: {
        this.state = o.SELF_CLOSING_START_TAG;
        break;
      }
      case i.EQUALS_SIGN: {
        this.state = o.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this.state = o.DATA, this.emitCurrentTagToken();
        break;
      }
      case i.EOF: {
        this._err(E.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = o.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
        break;
      case i.QUOTATION_MARK: {
        this.state = o.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case i.APOSTROPHE: {
        this.state = o.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.missingAttributeValue), this.state = o.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = o.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case i.QUOTATION_MARK: {
        this.state = o.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case i.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this.currentAttr.value += D;
        break;
      }
      case i.EOF: {
        this._err(E.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case i.APOSTROPHE: {
        this.state = o.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case i.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this.currentAttr.value += D;
        break;
      }
      case i.EOF: {
        this._err(E.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED: {
        this._leaveAttrValue(), this.state = o.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case i.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = o.DATA, this.emitCurrentTagToken();
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), this.currentAttr.value += D;
        break;
      }
      case i.QUOTATION_MARK:
      case i.APOSTROPHE:
      case i.LESS_THAN_SIGN:
      case i.EQUALS_SIGN:
      case i.GRAVE_ACCENT: {
        this._err(E.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case i.EOF: {
        this._err(E.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED: {
        this._leaveAttrValue(), this.state = o.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case i.SOLIDUS: {
        this._leaveAttrValue(), this.state = o.SELF_CLOSING_START_TAG;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = o.DATA, this.emitCurrentTagToken();
        break;
      }
      case i.EOF: {
        this._err(E.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.missingWhitespaceBetweenAttributes), this.state = o.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case i.GREATER_THAN_SIGN: {
        const u = this.currentToken;
        u.selfClosing = !0, this.state = o.DATA, this.emitCurrentTagToken();
        break;
      }
      case i.EOF: {
        this._err(E.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.unexpectedSolidusInTag), this.state = o.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const u = this.currentToken;
    switch (t) {
      case i.GREATER_THAN_SIGN: {
        this.state = o.DATA, this.emitCurrentComment(u);
        break;
      }
      case i.EOF: {
        this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), u.data += D;
        break;
      }
      default:
        u.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(F.DASH_DASH, !0) ? (this._createCommentToken(F.DASH_DASH.length + 1), this.state = o.COMMENT_START) : this._consumeSequenceIfMatch(F.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(F.DOCTYPE.length + 1), this.state = o.DOCTYPE) : this._consumeSequenceIfMatch(F.CDATA_START, !0) ? this.inForeignNode ? this.state = o.CDATA_SECTION : (this._err(E.cdataInHtmlContent), this._createCommentToken(F.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = o.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(E.incorrectlyOpenedComment), this._createCommentToken(2), this.state = o.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case i.HYPHEN_MINUS: {
        this.state = o.COMMENT_START_DASH;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.abruptClosingOfEmptyComment), this.state = o.DATA;
        const u = this.currentToken;
        this.emitCurrentComment(u);
        break;
      }
      default:
        this.state = o.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const u = this.currentToken;
    switch (t) {
      case i.HYPHEN_MINUS: {
        this.state = o.COMMENT_END;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.abruptClosingOfEmptyComment), this.state = o.DATA, this.emitCurrentComment(u);
        break;
      }
      case i.EOF: {
        this._err(E.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += "-", this.state = o.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const u = this.currentToken;
    switch (t) {
      case i.HYPHEN_MINUS: {
        this.state = o.COMMENT_END_DASH;
        break;
      }
      case i.LESS_THAN_SIGN: {
        u.data += "<", this.state = o.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), u.data += D;
        break;
      }
      case i.EOF: {
        this._err(E.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const u = this.currentToken;
    switch (t) {
      case i.EXCLAMATION_MARK: {
        u.data += "!", this.state = o.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case i.LESS_THAN_SIGN: {
        u.data += "<";
        break;
      }
      default:
        this.state = o.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === i.HYPHEN_MINUS ? this.state = o.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = o.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === i.HYPHEN_MINUS ? this.state = o.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = o.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== i.GREATER_THAN_SIGN && t !== i.EOF && this._err(E.nestedComment), this.state = o.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const u = this.currentToken;
    switch (t) {
      case i.HYPHEN_MINUS: {
        this.state = o.COMMENT_END;
        break;
      }
      case i.EOF: {
        this._err(E.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += "-", this.state = o.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const u = this.currentToken;
    switch (t) {
      case i.GREATER_THAN_SIGN: {
        this.state = o.DATA, this.emitCurrentComment(u);
        break;
      }
      case i.EXCLAMATION_MARK: {
        this.state = o.COMMENT_END_BANG;
        break;
      }
      case i.HYPHEN_MINUS: {
        u.data += "-";
        break;
      }
      case i.EOF: {
        this._err(E.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += "--", this.state = o.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const u = this.currentToken;
    switch (t) {
      case i.HYPHEN_MINUS: {
        u.data += "--!", this.state = o.COMMENT_END_DASH;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.incorrectlyClosedComment), this.state = o.DATA, this.emitCurrentComment(u);
        break;
      }
      case i.EOF: {
        this._err(E.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += "--!", this.state = o.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED: {
        this.state = o.BEFORE_DOCTYPE_NAME;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this.state = o.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), this._createDoctypeToken(null);
        const u = this.currentToken;
        u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.missingWhitespaceBeforeDoctypeName), this.state = o.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (Ee(t))
      this._createDoctypeToken(String.fromCharCode(xe(t))), this.state = o.DOCTYPE_NAME;
    else
      switch (t) {
        case i.SPACE:
        case i.LINE_FEED:
        case i.TABULATION:
        case i.FORM_FEED:
          break;
        case i.NULL: {
          this._err(E.unexpectedNullCharacter), this._createDoctypeToken(D), this.state = o.DOCTYPE_NAME;
          break;
        }
        case i.GREATER_THAN_SIGN: {
          this._err(E.missingDoctypeName), this._createDoctypeToken(null);
          const u = this.currentToken;
          u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = o.DATA;
          break;
        }
        case i.EOF: {
          this._err(E.eofInDoctype), this._createDoctypeToken(null);
          const u = this.currentToken;
          u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = o.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED: {
        this.state = o.AFTER_DOCTYPE_NAME;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this.state = o.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), u.name += D;
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.name += String.fromCodePoint(Ee(t) ? xe(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
        break;
      case i.GREATER_THAN_SIGN: {
        this.state = o.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(F.PUBLIC, !1) ? this.state = o.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(F.SYSTEM, !1) ? this.state = o.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(E.invalidCharacterSequenceAfterDoctypeName), u.forceQuirks = !0, this.state = o.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED: {
        this.state = o.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case i.QUOTATION_MARK: {
        this._err(E.missingWhitespaceAfterDoctypePublicKeyword), u.publicId = "", this.state = o.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case i.APOSTROPHE: {
        this._err(E.missingWhitespaceAfterDoctypePublicKeyword), u.publicId = "", this.state = o.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.missingDoctypePublicIdentifier), u.forceQuirks = !0, this.state = o.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.missingQuoteBeforeDoctypePublicIdentifier), u.forceQuirks = !0, this.state = o.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
        break;
      case i.QUOTATION_MARK: {
        u.publicId = "", this.state = o.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case i.APOSTROPHE: {
        u.publicId = "", this.state = o.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.missingDoctypePublicIdentifier), u.forceQuirks = !0, this.state = o.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.missingQuoteBeforeDoctypePublicIdentifier), u.forceQuirks = !0, this.state = o.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const u = this.currentToken;
    switch (t) {
      case i.QUOTATION_MARK: {
        this.state = o.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), u.publicId += D;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.abruptDoctypePublicIdentifier), u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = o.DATA;
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const u = this.currentToken;
    switch (t) {
      case i.APOSTROPHE: {
        this.state = o.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), u.publicId += D;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.abruptDoctypePublicIdentifier), u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = o.DATA;
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED: {
        this.state = o.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this.state = o.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case i.QUOTATION_MARK: {
        this._err(E.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), u.systemId = "", this.state = o.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case i.APOSTROPHE: {
        this._err(E.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), u.systemId = "", this.state = o.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.missingQuoteBeforeDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = o.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
        break;
      case i.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(u), this.state = o.DATA;
        break;
      }
      case i.QUOTATION_MARK: {
        u.systemId = "", this.state = o.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case i.APOSTROPHE: {
        u.systemId = "", this.state = o.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.missingQuoteBeforeDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = o.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED: {
        this.state = o.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case i.QUOTATION_MARK: {
        this._err(E.missingWhitespaceAfterDoctypeSystemKeyword), u.systemId = "", this.state = o.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case i.APOSTROPHE: {
        this._err(E.missingWhitespaceAfterDoctypeSystemKeyword), u.systemId = "", this.state = o.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.missingDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = o.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.missingQuoteBeforeDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = o.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
        break;
      case i.QUOTATION_MARK: {
        u.systemId = "", this.state = o.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case i.APOSTROPHE: {
        u.systemId = "", this.state = o.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.missingDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = o.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.missingQuoteBeforeDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = o.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const u = this.currentToken;
    switch (t) {
      case i.QUOTATION_MARK: {
        this.state = o.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), u.systemId += D;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.abruptDoctypeSystemIdentifier), u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = o.DATA;
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const u = this.currentToken;
    switch (t) {
      case i.APOSTROPHE: {
        this.state = o.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter), u.systemId += D;
        break;
      }
      case i.GREATER_THAN_SIGN: {
        this._err(E.abruptDoctypeSystemIdentifier), u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = o.DATA;
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const u = this.currentToken;
    switch (t) {
      case i.SPACE:
      case i.LINE_FEED:
      case i.TABULATION:
      case i.FORM_FEED:
        break;
      case i.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(u), this.state = o.DATA;
        break;
      }
      case i.EOF: {
        this._err(E.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(E.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = o.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const u = this.currentToken;
    switch (t) {
      case i.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(u), this.state = o.DATA;
        break;
      }
      case i.NULL: {
        this._err(E.unexpectedNullCharacter);
        break;
      }
      case i.EOF: {
        this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case i.RIGHT_SQUARE_BRACKET: {
        this.state = o.CDATA_SECTION_BRACKET;
        break;
      }
      case i.EOF: {
        this._err(E.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === i.RIGHT_SQUARE_BRACKET ? this.state = o.CDATA_SECTION_END : (this._emitChars("]"), this.state = o.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case i.GREATER_THAN_SIGN: {
        this.state = o.DATA;
        break;
      }
      case i.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = o.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0)
      if (this.preprocessor.lastChunkWritten)
        t = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(i.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && iu(this.preprocessor.peek(1)) ? o.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    iu(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === i.SEMICOLON && this._err(E.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
}
const fa = /* @__PURE__ */ new Set([s.DD, s.DT, s.LI, s.OPTGROUP, s.OPTION, s.P, s.RB, s.RP, s.RT, s.RTC]), ou = /* @__PURE__ */ new Set([
  ...fa,
  s.CAPTION,
  s.COLGROUP,
  s.TBODY,
  s.TD,
  s.TFOOT,
  s.TH,
  s.THEAD,
  s.TR
]), We = /* @__PURE__ */ new Set([
  s.APPLET,
  s.CAPTION,
  s.HTML,
  s.MARQUEE,
  s.OBJECT,
  s.TABLE,
  s.TD,
  s.TEMPLATE,
  s.TH
]), Ai = /* @__PURE__ */ new Set([...We, s.OL, s.UL]), pi = /* @__PURE__ */ new Set([...We, s.BUTTON]), du = /* @__PURE__ */ new Set([s.ANNOTATION_XML, s.MI, s.MN, s.MO, s.MS, s.MTEXT]), lu = /* @__PURE__ */ new Set([s.DESC, s.FOREIGN_OBJECT, s.TITLE]), gi = /* @__PURE__ */ new Set([s.TR, s.TEMPLATE, s.HTML]), Ni = /* @__PURE__ */ new Set([s.TBODY, s.TFOOT, s.THEAD, s.TEMPLATE, s.HTML]), Ci = /* @__PURE__ */ new Set([s.TABLE, s.TEMPLATE, s.HTML]), Ii = /* @__PURE__ */ new Set([s.TD, s.TH]);
class Si {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, u, a) {
    this.treeAdapter = u, this.handler = a, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = s.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === s.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === b.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, u) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = u, this.currentTagId = u, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, u, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, u) {
    const a = this._indexOf(t);
    this.items[a] = u, a === this.stackTop && (this.current = u);
  }
  insertAfter(t, u, a) {
    const r = this._indexOf(t) + 1;
    this.items.splice(r, 0, u), this.tagIDs.splice(r, 0, a), this.stackTop++, r === this.stackTop && this._updateCurrentElement(), this.handler.onItemPush(this.current, this.currentTagId, r === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let u = this.stackTop + 1;
    do
      u = this.tagIDs.lastIndexOf(t, u - 1);
    while (u > 0 && this.treeAdapter.getNamespaceURI(this.items[u]) !== b.HTML);
    this.shortenToLength(u < 0 ? 0 : u);
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const u = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(u, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const u = this._indexOf(t);
    this.shortenToLength(u < 0 ? 0 : u);
  }
  popUntilPopped(t, u) {
    const a = this._indexOfTagNames(t, u);
    this.shortenToLength(a < 0 ? 0 : a);
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(gt, b.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(Ii, b.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, u) {
    for (let a = this.stackTop; a >= 0; a--)
      if (t.has(this.tagIDs[a]) && this.treeAdapter.getNamespaceURI(this.items[a]) === u)
        return a;
    return -1;
  }
  clearBackTo(t, u) {
    const a = this._indexOfTagNames(t, u);
    this.shortenToLength(a + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(Ci, b.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(Ni, b.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(gi, b.HTML);
  }
  remove(t) {
    const u = this._indexOf(t);
    u >= 0 && (u === this.stackTop ? this.pop() : (this.items.splice(u, 1), this.tagIDs.splice(u, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === s.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const u = this._indexOf(t) - 1;
    return u >= 0 ? this.items[u] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === s.HTML;
  }
  //Element in scope
  hasInDynamicScope(t, u) {
    for (let a = this.stackTop; a >= 0; a--) {
      const r = this.tagIDs[a];
      switch (this.treeAdapter.getNamespaceURI(this.items[a])) {
        case b.HTML: {
          if (r === t)
            return !0;
          if (u.has(r))
            return !1;
          break;
        }
        case b.SVG: {
          if (lu.has(r))
            return !1;
          break;
        }
        case b.MATHML: {
          if (du.has(r))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, We);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, Ai);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, pi);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const u = this.tagIDs[t];
      switch (this.treeAdapter.getNamespaceURI(this.items[t])) {
        case b.HTML: {
          if (gt.has(u))
            return !0;
          if (We.has(u))
            return !1;
          break;
        }
        case b.SVG: {
          if (lu.has(u))
            return !1;
          break;
        }
        case b.MATHML: {
          if (du.has(u))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let u = this.stackTop; u >= 0; u--)
      if (this.treeAdapter.getNamespaceURI(this.items[u]) === b.HTML)
        switch (this.tagIDs[u]) {
          case t:
            return !0;
          case s.TABLE:
          case s.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === b.HTML)
        switch (this.tagIDs[t]) {
          case s.TBODY:
          case s.THEAD:
          case s.TFOOT:
            return !0;
          case s.TABLE:
          case s.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(t) {
    for (let u = this.stackTop; u >= 0; u--)
      if (this.treeAdapter.getNamespaceURI(this.items[u]) === b.HTML)
        switch (this.tagIDs[u]) {
          case t:
            return !0;
          case s.OPTION:
          case s.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; fa.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; ou.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== t && ou.has(this.currentTagId); )
      this.pop();
  }
}
const ht = 3;
var q;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(q || (q = {}));
const fu = { type: q.Marker };
class Oi {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, u) {
    const a = [], r = u.length, n = this.treeAdapter.getTagName(t), c = this.treeAdapter.getNamespaceURI(t);
    for (let l = 0; l < this.entries.length; l++) {
      const h = this.entries[l];
      if (h.type === q.Marker)
        break;
      const { element: T } = h;
      if (this.treeAdapter.getTagName(T) === n && this.treeAdapter.getNamespaceURI(T) === c) {
        const _ = this.treeAdapter.getAttrList(T);
        _.length === r && a.push({ idx: l, attrs: _ });
      }
    }
    return a;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < ht)
      return;
    const u = this.treeAdapter.getAttrList(t), a = this._getNoahArkConditionCandidates(t, u);
    if (a.length < ht)
      return;
    const r = new Map(u.map((c) => [c.name, c.value]));
    let n = 0;
    for (let c = 0; c < a.length; c++) {
      const l = a[c];
      l.attrs.every((h) => r.get(h.name) === h.value) && (n += 1, n >= ht && this.entries.splice(l.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(fu);
  }
  pushElement(t, u) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: q.Element,
      element: t,
      token: u
    });
  }
  insertElementAfterBookmark(t, u) {
    const a = this.entries.indexOf(this.bookmark);
    this.entries.splice(a, 0, {
      type: q.Element,
      element: t,
      token: u
    });
  }
  removeEntry(t) {
    const u = this.entries.indexOf(t);
    u >= 0 && this.entries.splice(u, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(fu);
    t >= 0 ? this.entries.splice(0, t + 1) : this.entries.length = 0;
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const u = this.entries.find((a) => a.type === q.Marker || this.treeAdapter.getTagName(a.element) === t);
    return u && u.type === q.Element ? u : null;
  }
  getElementEntry(t) {
    return this.entries.find((u) => u.type === q.Element && u.element === t);
  }
}
const W = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: v.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, t, u) {
    return {
      nodeName: e,
      tagName: e,
      attrs: u,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, t) {
    e.childNodes.push(t), t.parentNode = e;
  },
  insertBefore(e, t, u) {
    const a = e.childNodes.indexOf(u);
    e.childNodes.splice(a, 0, t), t.parentNode = e;
  },
  setTemplateContent(e, t) {
    e.content = t;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, t, u, a) {
    const r = e.childNodes.find((n) => n.nodeName === "#documentType");
    if (r)
      r.name = t, r.publicId = u, r.systemId = a;
    else {
      const n = {
        nodeName: "#documentType",
        name: t,
        publicId: u,
        systemId: a,
        parentNode: null
      };
      W.appendChild(e, n);
    }
  },
  setDocumentMode(e, t) {
    e.mode = t;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const t = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
  },
  insertText(e, t) {
    if (e.childNodes.length > 0) {
      const u = e.childNodes[e.childNodes.length - 1];
      if (W.isTextNode(u)) {
        u.value += t;
        return;
      }
    }
    W.appendChild(e, W.createTextNode(t));
  },
  insertTextBefore(e, t, u) {
    const a = e.childNodes[e.childNodes.indexOf(u) - 1];
    a && W.isTextNode(a) ? a.value += t : W.insertBefore(e, W.createTextNode(t), u);
  },
  adoptAttributes(e, t) {
    const u = new Set(e.attrs.map((a) => a.name));
    for (let a = 0; a < t.length; a++)
      u.has(t[a].name) || e.attrs.push(t[a]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...t };
  }
}, ha = "html", Li = "about:legacy-compat", Di = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", Ea = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], Ri = [
  ...Ea,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], Pi = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), Ta = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], Mi = [
  ...Ta,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function hu(e, t) {
  return t.some((u) => e.startsWith(u));
}
function xi(e) {
  return e.name === ha && e.publicId === null && (e.systemId === null || e.systemId === Li);
}
function yi(e) {
  if (e.name !== ha)
    return v.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === Di)
    return v.QUIRKS;
  let { publicId: u } = e;
  if (u !== null) {
    if (u = u.toLowerCase(), Pi.has(u))
      return v.QUIRKS;
    let a = t === null ? Ri : Ea;
    if (hu(u, a))
      return v.QUIRKS;
    if (a = t === null ? Ta : Mi, hu(u, a))
      return v.LIMITED_QUIRKS;
  }
  return v.NO_QUIRKS;
}
const Eu = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, Bi = "definitionurl", ki = "definitionURL", Fi = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), Ui = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: b.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: b.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: b.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: b.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: b.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: b.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: b.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: b.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: b.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: b.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: b.XMLNS }]
]), Hi = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), wi = /* @__PURE__ */ new Set([
  s.B,
  s.BIG,
  s.BLOCKQUOTE,
  s.BODY,
  s.BR,
  s.CENTER,
  s.CODE,
  s.DD,
  s.DIV,
  s.DL,
  s.DT,
  s.EM,
  s.EMBED,
  s.H1,
  s.H2,
  s.H3,
  s.H4,
  s.H5,
  s.H6,
  s.HEAD,
  s.HR,
  s.I,
  s.IMG,
  s.LI,
  s.LISTING,
  s.MENU,
  s.META,
  s.NOBR,
  s.OL,
  s.P,
  s.PRE,
  s.RUBY,
  s.S,
  s.SMALL,
  s.SPAN,
  s.STRONG,
  s.STRIKE,
  s.SUB,
  s.SUP,
  s.TABLE,
  s.TT,
  s.U,
  s.UL,
  s.VAR
]);
function vi(e) {
  const t = e.tagID;
  return t === s.FONT && e.attrs.some(({ name: a }) => a === J.COLOR || a === J.SIZE || a === J.FACE) || wi.has(t);
}
function ba(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === Bi) {
      e.attrs[t].name = ki;
      break;
    }
}
function ma(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const u = Fi.get(e.attrs[t].name);
    u != null && (e.attrs[t].name = u);
  }
}
function Yt(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const u = Ui.get(e.attrs[t].name);
    u && (e.attrs[t].prefix = u.prefix, e.attrs[t].name = u.name, e.attrs[t].namespace = u.namespace);
  }
}
function Yi(e) {
  const t = Hi.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = Je(e.tagName));
}
function qi(e, t) {
  return t === b.MATHML && (e === s.MI || e === s.MO || e === s.MN || e === s.MS || e === s.MTEXT);
}
function Wi(e, t, u) {
  if (t === b.MATHML && e === s.ANNOTATION_XML) {
    for (let a = 0; a < u.length; a++)
      if (u[a].name === J.ENCODING) {
        const r = u[a].value.toLowerCase();
        return r === Eu.TEXT_HTML || r === Eu.APPLICATION_XML;
      }
  }
  return t === b.SVG && (e === s.FOREIGN_OBJECT || e === s.DESC || e === s.TITLE);
}
function Qi(e, t, u, a) {
  return (!a || a === b.HTML) && Wi(e, t, u) || (!a || a === b.MATHML) && qi(e, t);
}
const Gi = "hidden", Vi = 8, Xi = 3;
var d;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(d || (d = {}));
const Ki = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, _a = /* @__PURE__ */ new Set([s.TABLE, s.TBODY, s.TFOOT, s.THEAD, s.TR]), Tu = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: W,
  onParseError: null
};
class w0 {
  constructor(t, u, a = null, r = null) {
    this.fragmentContext = a, this.scriptHandler = r, this.currentToken = null, this.stopped = !1, this.insertionMode = d.INITIAL, this.originalInsertionMode = d.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...Tu,
      ...t
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = u ?? this.treeAdapter.createDocument(), this.tokenizer = new _i(this.options, this), this.activeFormattingElements = new Oi(this.treeAdapter), this.fragmentContextID = a ? Je(this.treeAdapter.getTagName(a)) : s.UNKNOWN, this._setContextModes(a ?? this.document, this.fragmentContextID), this.openElements = new Si(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, u) {
    const a = new this(u);
    return a.tokenizer.write(t, !0), a.document;
  }
  static getFragmentParser(t, u) {
    const a = {
      ...Tu,
      ...u
    };
    t ?? (t = a.treeAdapter.createElement(f.TEMPLATE, b.HTML, []));
    const r = a.treeAdapter.createElement("documentmock", b.HTML, []), n = new this(a, r, t);
    return n.fragmentContextID === s.TEMPLATE && n.tmplInsertionModeStack.unshift(d.IN_TEMPLATE), n._initTokenizerForFragmentParsing(), n._insertFakeRootElement(), n._resetInsertionMode(), n._findFormInFragmentContext(), n;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), u = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, u), u;
  }
  //Errors
  /** @internal */
  _err(t, u, a) {
    var r;
    if (!this.onParseError)
      return;
    const n = (r = t.location) !== null && r !== void 0 ? r : Ki, c = {
      code: u,
      startLine: n.startLine,
      startCol: n.startCol,
      startOffset: n.startOffset,
      endLine: a ? n.startLine : n.endLine,
      endCol: a ? n.startCol : n.endCol,
      endOffset: a ? n.startOffset : n.endOffset
    };
    this.onParseError(c);
  }
  //Stack events
  /** @internal */
  onItemPush(t, u, a) {
    var r, n;
    (n = (r = this.treeAdapter).onItemPush) === null || n === void 0 || n.call(r, t), a && this.openElements.stackTop > 0 && this._setContextModes(t, u);
  }
  /** @internal */
  onItemPop(t, u) {
    var a, r;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (r = (a = this.treeAdapter).onItemPop) === null || r === void 0 || r.call(a, t, this.openElements.current), u) {
      let n, c;
      this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, c = this.fragmentContextID) : { current: n, currentTagId: c } = this.openElements, this._setContextModes(n, c);
    }
  }
  _setContextModes(t, u) {
    const a = t === this.document || this.treeAdapter.getNamespaceURI(t) === b.HTML;
    this.currentNotInHTML = !a, this.tokenizer.inForeignNode = !a && !this._isIntegrationPoint(u, t);
  }
  /** @protected */
  _switchToTextParsing(t, u) {
    this._insertElement(t, b.HTML), this.tokenizer.state = u, this.originalInsertionMode = this.insertionMode, this.insertionMode = d.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = d.TEXT, this.originalInsertionMode = d.IN_BODY, this.tokenizer.state = H.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === f.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== b.HTML))
      switch (this.fragmentContextID) {
        case s.TITLE:
        case s.TEXTAREA: {
          this.tokenizer.state = H.RCDATA;
          break;
        }
        case s.STYLE:
        case s.XMP:
        case s.IFRAME:
        case s.NOEMBED:
        case s.NOFRAMES:
        case s.NOSCRIPT: {
          this.tokenizer.state = H.RAWTEXT;
          break;
        }
        case s.SCRIPT: {
          this.tokenizer.state = H.SCRIPT_DATA;
          break;
        }
        case s.PLAINTEXT: {
          this.tokenizer.state = H.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(t) {
    const u = t.name || "", a = t.publicId || "", r = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, u, a, r), t.location) {
      const c = this.treeAdapter.getChildNodes(this.document).find((l) => this.treeAdapter.isDocumentTypeNode(l));
      c && this.treeAdapter.setNodeSourceCodeLocation(c, t.location);
    }
  }
  /** @protected */
  _attachElementToTree(t, u) {
    if (this.options.sourceCodeLocationInfo) {
      const a = u && {
        ...u,
        startTag: u
      };
      this.treeAdapter.setNodeSourceCodeLocation(t, a);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const a = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(a, t);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(t, u) {
    const a = this.treeAdapter.createElement(t.tagName, u, t.attrs);
    this._attachElementToTree(a, t.location);
  }
  /** @protected */
  _insertElement(t, u) {
    const a = this.treeAdapter.createElement(t.tagName, u, t.attrs);
    this._attachElementToTree(a, t.location), this.openElements.push(a, t.tagID);
  }
  /** @protected */
  _insertFakeElement(t, u) {
    const a = this.treeAdapter.createElement(t, b.HTML, []);
    this._attachElementToTree(a, null), this.openElements.push(a, u);
  }
  /** @protected */
  _insertTemplate(t) {
    const u = this.treeAdapter.createElement(t.tagName, b.HTML, t.attrs), a = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(u, a), this._attachElementToTree(u, t.location), this.openElements.push(u, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(a, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(f.HTML, b.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, s.HTML);
  }
  /** @protected */
  _appendCommentNode(t, u) {
    const a = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(u, a), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
  }
  /** @protected */
  _insertCharacters(t) {
    let u, a;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: u, beforeElement: a } = this._findFosterParentingLocation(), a ? this.treeAdapter.insertTextBefore(u, t.chars, a) : this.treeAdapter.insertText(u, t.chars)) : (u = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(u, t.chars)), !t.location)
      return;
    const r = this.treeAdapter.getChildNodes(u), n = a ? r.lastIndexOf(a) : r.length, c = r[n - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(c)) {
      const { endLine: h, endCol: T, endOffset: _ } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(c, { endLine: h, endCol: T, endOffset: _ });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(c, t.location);
  }
  /** @protected */
  _adoptNodes(t, u) {
    for (let a = this.treeAdapter.getFirstChild(t); a; a = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(a), this.treeAdapter.appendChild(u, a);
  }
  /** @protected */
  _setEndLocation(t, u) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && u.location) {
      const a = u.location, r = this.treeAdapter.getTagName(t), n = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        u.type === O.END_TAG && r === u.tagName ? {
          endTag: { ...a },
          endLine: a.endLine,
          endCol: a.endCol,
          endOffset: a.endOffset
        } : {
          endLine: a.startLine,
          endCol: a.startCol,
          endOffset: a.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, n);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let u, a;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (u = this.fragmentContext, a = this.fragmentContextID) : { current: u, currentTagId: a } = this.openElements, t.tagID === s.SVG && this.treeAdapter.getTagName(u) === f.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(u) === b.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === s.MGLYPH || t.tagID === s.MALIGNMARK) && !this._isIntegrationPoint(a, u, b.HTML)
    );
  }
  /** @protected */
  _processToken(t) {
    switch (t.type) {
      case O.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case O.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case O.COMMENT: {
        this.onComment(t);
        break;
      }
      case O.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case O.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case O.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case O.EOF: {
        this.onEof(t);
        break;
      }
      case O.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(t, u, a) {
    const r = this.treeAdapter.getNamespaceURI(u), n = this.treeAdapter.getAttrList(u);
    return Qi(t, r, n, a);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const u = this.activeFormattingElements.entries.findIndex((r) => r.type === q.Marker || this.openElements.contains(r.element)), a = u < 0 ? t - 1 : u - 1;
      for (let r = a; r >= 0; r--) {
        const n = this.activeFormattingElements.entries[r];
        this._insertElement(n.token, this.treeAdapter.getNamespaceURI(n.element)), n.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = d.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(s.P), this.openElements.popUntilTagNamePopped(s.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case s.TR: {
          this.insertionMode = d.IN_ROW;
          return;
        }
        case s.TBODY:
        case s.THEAD:
        case s.TFOOT: {
          this.insertionMode = d.IN_TABLE_BODY;
          return;
        }
        case s.CAPTION: {
          this.insertionMode = d.IN_CAPTION;
          return;
        }
        case s.COLGROUP: {
          this.insertionMode = d.IN_COLUMN_GROUP;
          return;
        }
        case s.TABLE: {
          this.insertionMode = d.IN_TABLE;
          return;
        }
        case s.BODY: {
          this.insertionMode = d.IN_BODY;
          return;
        }
        case s.FRAMESET: {
          this.insertionMode = d.IN_FRAMESET;
          return;
        }
        case s.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case s.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case s.HTML: {
          this.insertionMode = this.headElement ? d.AFTER_HEAD : d.BEFORE_HEAD;
          return;
        }
        case s.TD:
        case s.TH: {
          if (t > 0) {
            this.insertionMode = d.IN_CELL;
            return;
          }
          break;
        }
        case s.HEAD: {
          if (t > 0) {
            this.insertionMode = d.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = d.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let u = t - 1; u > 0; u--) {
        const a = this.openElements.tagIDs[u];
        if (a === s.TEMPLATE)
          break;
        if (a === s.TABLE) {
          this.insertionMode = d.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = d.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(t) {
    return _a.has(t);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const u = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case s.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(u) === b.HTML)
            return { parent: this.treeAdapter.getTemplateContent(u), beforeElement: null };
          break;
        }
        case s.TABLE: {
          const a = this.treeAdapter.getParentNode(u);
          return a ? { parent: a, beforeElement: u } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(t) {
    const u = this._findFosterParentingLocation();
    u.beforeElement ? this.treeAdapter.insertBefore(u.parent, t, u.beforeElement) : this.treeAdapter.appendChild(u.parent, t);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(t, u) {
    const a = this.treeAdapter.getNamespaceURI(t);
    return fi[a].has(u);
  }
  /** @internal */
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      I0(this, t);
      return;
    }
    switch (this.insertionMode) {
      case d.INITIAL: {
        fe(this, t);
        break;
      }
      case d.BEFORE_HTML: {
        be(this, t);
        break;
      }
      case d.BEFORE_HEAD: {
        me(this, t);
        break;
      }
      case d.IN_HEAD: {
        _e(this, t);
        break;
      }
      case d.IN_HEAD_NO_SCRIPT: {
        Ae(this, t);
        break;
      }
      case d.AFTER_HEAD: {
        pe(this, t);
        break;
      }
      case d.IN_BODY:
      case d.IN_CAPTION:
      case d.IN_CELL:
      case d.IN_TEMPLATE: {
        pa(this, t);
        break;
      }
      case d.TEXT:
      case d.IN_SELECT:
      case d.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case d.IN_TABLE:
      case d.IN_TABLE_BODY:
      case d.IN_ROW: {
        Et(this, t);
        break;
      }
      case d.IN_TABLE_TEXT: {
        Oa(this, t);
        break;
      }
      case d.IN_COLUMN_GROUP: {
        Qe(this, t);
        break;
      }
      case d.AFTER_BODY: {
        Ge(this, t);
        break;
      }
      case d.AFTER_AFTER_BODY: {
        Be(this, t);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      C0(this, t);
      return;
    }
    switch (this.insertionMode) {
      case d.INITIAL: {
        fe(this, t);
        break;
      }
      case d.BEFORE_HTML: {
        be(this, t);
        break;
      }
      case d.BEFORE_HEAD: {
        me(this, t);
        break;
      }
      case d.IN_HEAD: {
        _e(this, t);
        break;
      }
      case d.IN_HEAD_NO_SCRIPT: {
        Ae(this, t);
        break;
      }
      case d.AFTER_HEAD: {
        pe(this, t);
        break;
      }
      case d.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case d.IN_TABLE:
      case d.IN_TABLE_BODY:
      case d.IN_ROW: {
        Et(this, t);
        break;
      }
      case d.IN_COLUMN_GROUP: {
        Qe(this, t);
        break;
      }
      case d.AFTER_BODY: {
        Ge(this, t);
        break;
      }
      case d.AFTER_AFTER_BODY: {
        Be(this, t);
        break;
      }
    }
  }
  /** @internal */
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      Nt(this, t);
      return;
    }
    switch (this.insertionMode) {
      case d.INITIAL:
      case d.BEFORE_HTML:
      case d.BEFORE_HEAD:
      case d.IN_HEAD:
      case d.IN_HEAD_NO_SCRIPT:
      case d.AFTER_HEAD:
      case d.IN_BODY:
      case d.IN_TABLE:
      case d.IN_CAPTION:
      case d.IN_COLUMN_GROUP:
      case d.IN_TABLE_BODY:
      case d.IN_ROW:
      case d.IN_CELL:
      case d.IN_SELECT:
      case d.IN_SELECT_IN_TABLE:
      case d.IN_TEMPLATE:
      case d.IN_FRAMESET:
      case d.AFTER_FRAMESET: {
        Nt(this, t);
        break;
      }
      case d.IN_TABLE_TEXT: {
        he(this, t);
        break;
      }
      case d.AFTER_BODY: {
        tc(this, t);
        break;
      }
      case d.AFTER_AFTER_BODY:
      case d.AFTER_AFTER_FRAMESET: {
        uc(this, t);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case d.INITIAL: {
        ac(this, t);
        break;
      }
      case d.BEFORE_HEAD:
      case d.IN_HEAD:
      case d.IN_HEAD_NO_SCRIPT:
      case d.AFTER_HEAD: {
        this._err(t, E.misplacedDoctype);
        break;
      }
      case d.IN_TABLE_TEXT: {
        he(this, t);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, E.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? S0(this, t) : this._startTagOutsideForeignContent(t);
  }
  /** @protected */
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case d.INITIAL: {
        fe(this, t);
        break;
      }
      case d.BEFORE_HTML: {
        sc(this, t);
        break;
      }
      case d.BEFORE_HEAD: {
        nc(this, t);
        break;
      }
      case d.IN_HEAD: {
        Y(this, t);
        break;
      }
      case d.IN_HEAD_NO_SCRIPT: {
        oc(this, t);
        break;
      }
      case d.AFTER_HEAD: {
        lc(this, t);
        break;
      }
      case d.IN_BODY: {
        B(this, t);
        break;
      }
      case d.IN_TABLE: {
        ne(this, t);
        break;
      }
      case d.IN_TABLE_TEXT: {
        he(this, t);
        break;
      }
      case d.IN_CAPTION: {
        i0(this, t);
        break;
      }
      case d.IN_COLUMN_GROUP: {
        Qt(this, t);
        break;
      }
      case d.IN_TABLE_BODY: {
        tt(this, t);
        break;
      }
      case d.IN_ROW: {
        ut(this, t);
        break;
      }
      case d.IN_CELL: {
        d0(this, t);
        break;
      }
      case d.IN_SELECT: {
        Ra(this, t);
        break;
      }
      case d.IN_SELECT_IN_TABLE: {
        f0(this, t);
        break;
      }
      case d.IN_TEMPLATE: {
        E0(this, t);
        break;
      }
      case d.AFTER_BODY: {
        b0(this, t);
        break;
      }
      case d.IN_FRAMESET: {
        m0(this, t);
        break;
      }
      case d.AFTER_FRAMESET: {
        A0(this, t);
        break;
      }
      case d.AFTER_AFTER_BODY: {
        g0(this, t);
        break;
      }
      case d.AFTER_AFTER_FRAMESET: {
        N0(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? O0(this, t) : this._endTagOutsideForeignContent(t);
  }
  /** @protected */
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case d.INITIAL: {
        fe(this, t);
        break;
      }
      case d.BEFORE_HTML: {
        rc(this, t);
        break;
      }
      case d.BEFORE_HEAD: {
        ic(this, t);
        break;
      }
      case d.IN_HEAD: {
        cc(this, t);
        break;
      }
      case d.IN_HEAD_NO_SCRIPT: {
        dc(this, t);
        break;
      }
      case d.AFTER_HEAD: {
        fc(this, t);
        break;
      }
      case d.IN_BODY: {
        et(this, t);
        break;
      }
      case d.TEXT: {
        zc(this, t);
        break;
      }
      case d.IN_TABLE: {
        Se(this, t);
        break;
      }
      case d.IN_TABLE_TEXT: {
        he(this, t);
        break;
      }
      case d.IN_CAPTION: {
        c0(this, t);
        break;
      }
      case d.IN_COLUMN_GROUP: {
        o0(this, t);
        break;
      }
      case d.IN_TABLE_BODY: {
        Ct(this, t);
        break;
      }
      case d.IN_ROW: {
        Da(this, t);
        break;
      }
      case d.IN_CELL: {
        l0(this, t);
        break;
      }
      case d.IN_SELECT: {
        Pa(this, t);
        break;
      }
      case d.IN_SELECT_IN_TABLE: {
        h0(this, t);
        break;
      }
      case d.IN_TEMPLATE: {
        T0(this, t);
        break;
      }
      case d.AFTER_BODY: {
        xa(this, t);
        break;
      }
      case d.IN_FRAMESET: {
        _0(this, t);
        break;
      }
      case d.AFTER_FRAMESET: {
        p0(this, t);
        break;
      }
      case d.AFTER_AFTER_BODY: {
        Be(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEof(t) {
    switch (this.insertionMode) {
      case d.INITIAL: {
        fe(this, t);
        break;
      }
      case d.BEFORE_HTML: {
        be(this, t);
        break;
      }
      case d.BEFORE_HEAD: {
        me(this, t);
        break;
      }
      case d.IN_HEAD: {
        _e(this, t);
        break;
      }
      case d.IN_HEAD_NO_SCRIPT: {
        Ae(this, t);
        break;
      }
      case d.AFTER_HEAD: {
        pe(this, t);
        break;
      }
      case d.IN_BODY:
      case d.IN_TABLE:
      case d.IN_CAPTION:
      case d.IN_COLUMN_GROUP:
      case d.IN_TABLE_BODY:
      case d.IN_ROW:
      case d.IN_CELL:
      case d.IN_SELECT:
      case d.IN_SELECT_IN_TABLE: {
        Ia(this, t);
        break;
      }
      case d.TEXT: {
        Jc(this, t);
        break;
      }
      case d.IN_TABLE_TEXT: {
        he(this, t);
        break;
      }
      case d.IN_TEMPLATE: {
        Ma(this, t);
        break;
      }
      case d.AFTER_BODY:
      case d.IN_FRAMESET:
      case d.AFTER_FRAMESET:
      case d.AFTER_AFTER_BODY:
      case d.AFTER_AFTER_FRAMESET: {
        Wt(this, t);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === i.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case d.IN_HEAD:
      case d.IN_HEAD_NO_SCRIPT:
      case d.AFTER_HEAD:
      case d.TEXT:
      case d.IN_COLUMN_GROUP:
      case d.IN_SELECT:
      case d.IN_SELECT_IN_TABLE:
      case d.IN_FRAMESET:
      case d.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case d.IN_BODY:
      case d.IN_CAPTION:
      case d.IN_CELL:
      case d.IN_TEMPLATE:
      case d.AFTER_BODY:
      case d.AFTER_AFTER_BODY:
      case d.AFTER_AFTER_FRAMESET: {
        Aa(this, t);
        break;
      }
      case d.IN_TABLE:
      case d.IN_TABLE_BODY:
      case d.IN_ROW: {
        Et(this, t);
        break;
      }
      case d.IN_TABLE_TEXT: {
        Sa(this, t);
        break;
      }
    }
  }
}
function ji(e, t) {
  let u = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return u ? e.openElements.contains(u.element) ? e.openElements.hasInScope(t.tagID) || (u = null) : (e.activeFormattingElements.removeEntry(u), u = null) : Ca(e, t), u;
}
function $i(e, t) {
  let u = null, a = e.openElements.stackTop;
  for (; a >= 0; a--) {
    const r = e.openElements.items[a];
    if (r === t.element)
      break;
    e._isSpecialElement(r, e.openElements.tagIDs[a]) && (u = r);
  }
  return u || (e.openElements.shortenToLength(a < 0 ? 0 : a), e.activeFormattingElements.removeEntry(t)), u;
}
function zi(e, t, u) {
  let a = t, r = e.openElements.getCommonAncestor(t);
  for (let n = 0, c = r; c !== u; n++, c = r) {
    r = e.openElements.getCommonAncestor(c);
    const l = e.activeFormattingElements.getElementEntry(c), h = l && n >= Xi;
    !l || h ? (h && e.activeFormattingElements.removeEntry(l), e.openElements.remove(c)) : (c = Ji(e, l), a === t && (e.activeFormattingElements.bookmark = l), e.treeAdapter.detachNode(a), e.treeAdapter.appendChild(c, a), a = c);
  }
  return a;
}
function Ji(e, t) {
  const u = e.treeAdapter.getNamespaceURI(t.element), a = e.treeAdapter.createElement(t.token.tagName, u, t.token.attrs);
  return e.openElements.replace(t.element, a), t.element = a, a;
}
function Zi(e, t, u) {
  const a = e.treeAdapter.getTagName(t), r = Je(a);
  if (e._isElementCausesFosterParenting(r))
    e._fosterParentElement(u);
  else {
    const n = e.treeAdapter.getNamespaceURI(t);
    r === s.TEMPLATE && n === b.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, u);
  }
}
function ec(e, t, u) {
  const a = e.treeAdapter.getNamespaceURI(u.element), { token: r } = u, n = e.treeAdapter.createElement(r.tagName, a, r.attrs);
  e._adoptNodes(t, n), e.treeAdapter.appendChild(t, n), e.activeFormattingElements.insertElementAfterBookmark(n, r), e.activeFormattingElements.removeEntry(u), e.openElements.remove(u.element), e.openElements.insertAfter(t, n, r.tagID);
}
function qt(e, t) {
  for (let u = 0; u < Vi; u++) {
    const a = ji(e, t);
    if (!a)
      break;
    const r = $i(e, a);
    if (!r)
      break;
    e.activeFormattingElements.bookmark = a;
    const n = zi(e, r, a.element), c = e.openElements.getCommonAncestor(a.element);
    e.treeAdapter.detachNode(n), c && Zi(e, c, n), ec(e, r, a);
  }
}
function Nt(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function tc(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function uc(e, t) {
  e._appendCommentNode(t, e.document);
}
function Wt(e, t) {
  if (e.stopped = !0, t.location) {
    const u = e.fragmentContext ? 0 : 2;
    for (let a = e.openElements.stackTop; a >= u; a--)
      e._setEndLocation(e.openElements.items[a], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const a = e.openElements.items[0], r = e.treeAdapter.getNodeSourceCodeLocation(a);
      if (r && !r.endTag && (e._setEndLocation(a, t), e.openElements.stackTop >= 1)) {
        const n = e.openElements.items[1], c = e.treeAdapter.getNodeSourceCodeLocation(n);
        c && !c.endTag && e._setEndLocation(n, t);
      }
    }
  }
}
function ac(e, t) {
  e._setDocumentType(t);
  const u = t.forceQuirks ? v.QUIRKS : yi(t);
  xi(t) || e._err(t, E.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, u), e.insertionMode = d.BEFORE_HTML;
}
function fe(e, t) {
  e._err(t, E.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, v.QUIRKS), e.insertionMode = d.BEFORE_HTML, e._processToken(t);
}
function sc(e, t) {
  t.tagID === s.HTML ? (e._insertElement(t, b.HTML), e.insertionMode = d.BEFORE_HEAD) : be(e, t);
}
function rc(e, t) {
  const u = t.tagID;
  (u === s.HTML || u === s.HEAD || u === s.BODY || u === s.BR) && be(e, t);
}
function be(e, t) {
  e._insertFakeRootElement(), e.insertionMode = d.BEFORE_HEAD, e._processToken(t);
}
function nc(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      B(e, t);
      break;
    }
    case s.HEAD: {
      e._insertElement(t, b.HTML), e.headElement = e.openElements.current, e.insertionMode = d.IN_HEAD;
      break;
    }
    default:
      me(e, t);
  }
}
function ic(e, t) {
  const u = t.tagID;
  u === s.HEAD || u === s.BODY || u === s.HTML || u === s.BR ? me(e, t) : e._err(t, E.endTagWithoutMatchingOpenElement);
}
function me(e, t) {
  e._insertFakeElement(f.HEAD, s.HEAD), e.headElement = e.openElements.current, e.insertionMode = d.IN_HEAD, e._processToken(t);
}
function Y(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      B(e, t);
      break;
    }
    case s.BASE:
    case s.BASEFONT:
    case s.BGSOUND:
    case s.LINK:
    case s.META: {
      e._appendElement(t, b.HTML), t.ackSelfClosing = !0;
      break;
    }
    case s.TITLE: {
      e._switchToTextParsing(t, H.RCDATA);
      break;
    }
    case s.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, H.RAWTEXT) : (e._insertElement(t, b.HTML), e.insertionMode = d.IN_HEAD_NO_SCRIPT);
      break;
    }
    case s.NOFRAMES:
    case s.STYLE: {
      e._switchToTextParsing(t, H.RAWTEXT);
      break;
    }
    case s.SCRIPT: {
      e._switchToTextParsing(t, H.SCRIPT_DATA);
      break;
    }
    case s.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = d.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(d.IN_TEMPLATE);
      break;
    }
    case s.HEAD: {
      e._err(t, E.misplacedStartTagForHeadElement);
      break;
    }
    default:
      _e(e, t);
  }
}
function cc(e, t) {
  switch (t.tagID) {
    case s.HEAD: {
      e.openElements.pop(), e.insertionMode = d.AFTER_HEAD;
      break;
    }
    case s.BODY:
    case s.BR:
    case s.HTML: {
      _e(e, t);
      break;
    }
    case s.TEMPLATE: {
      ae(e, t);
      break;
    }
    default:
      e._err(t, E.endTagWithoutMatchingOpenElement);
  }
}
function ae(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== s.TEMPLATE && e._err(t, E.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(s.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, E.endTagWithoutMatchingOpenElement);
}
function _e(e, t) {
  e.openElements.pop(), e.insertionMode = d.AFTER_HEAD, e._processToken(t);
}
function oc(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      B(e, t);
      break;
    }
    case s.BASEFONT:
    case s.BGSOUND:
    case s.HEAD:
    case s.LINK:
    case s.META:
    case s.NOFRAMES:
    case s.STYLE: {
      Y(e, t);
      break;
    }
    case s.NOSCRIPT: {
      e._err(t, E.nestedNoscriptInHead);
      break;
    }
    default:
      Ae(e, t);
  }
}
function dc(e, t) {
  switch (t.tagID) {
    case s.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = d.IN_HEAD;
      break;
    }
    case s.BR: {
      Ae(e, t);
      break;
    }
    default:
      e._err(t, E.endTagWithoutMatchingOpenElement);
  }
}
function Ae(e, t) {
  const u = t.type === O.EOF ? E.openElementsLeftAfterEof : E.disallowedContentInNoscriptInHead;
  e._err(t, u), e.openElements.pop(), e.insertionMode = d.IN_HEAD, e._processToken(t);
}
function lc(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      B(e, t);
      break;
    }
    case s.BODY: {
      e._insertElement(t, b.HTML), e.framesetOk = !1, e.insertionMode = d.IN_BODY;
      break;
    }
    case s.FRAMESET: {
      e._insertElement(t, b.HTML), e.insertionMode = d.IN_FRAMESET;
      break;
    }
    case s.BASE:
    case s.BASEFONT:
    case s.BGSOUND:
    case s.LINK:
    case s.META:
    case s.NOFRAMES:
    case s.SCRIPT:
    case s.STYLE:
    case s.TEMPLATE:
    case s.TITLE: {
      e._err(t, E.abandonedHeadElementChild), e.openElements.push(e.headElement, s.HEAD), Y(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case s.HEAD: {
      e._err(t, E.misplacedStartTagForHeadElement);
      break;
    }
    default:
      pe(e, t);
  }
}
function fc(e, t) {
  switch (t.tagID) {
    case s.BODY:
    case s.HTML:
    case s.BR: {
      pe(e, t);
      break;
    }
    case s.TEMPLATE: {
      ae(e, t);
      break;
    }
    default:
      e._err(t, E.endTagWithoutMatchingOpenElement);
  }
}
function pe(e, t) {
  e._insertFakeElement(f.BODY, s.BODY), e.insertionMode = d.IN_BODY, Ze(e, t);
}
function Ze(e, t) {
  switch (t.type) {
    case O.CHARACTER: {
      pa(e, t);
      break;
    }
    case O.WHITESPACE_CHARACTER: {
      Aa(e, t);
      break;
    }
    case O.COMMENT: {
      Nt(e, t);
      break;
    }
    case O.START_TAG: {
      B(e, t);
      break;
    }
    case O.END_TAG: {
      et(e, t);
      break;
    }
    case O.EOF: {
      Ia(e, t);
      break;
    }
  }
}
function Aa(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function pa(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function hc(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function Ec(e, t) {
  const u = e.openElements.tryPeekProperlyNestedBodyElement();
  u && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(u, t.attrs));
}
function Tc(e, t) {
  const u = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && u && (e.treeAdapter.detachNode(u), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, b.HTML), e.insertionMode = d.IN_FRAMESET);
}
function bc(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, b.HTML);
}
function mc(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), gt.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, b.HTML);
}
function _c(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, b.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function Ac(e, t) {
  const u = e.openElements.tmplCount > 0;
  (!e.formElement || u) && (e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, b.HTML), u || (e.formElement = e.openElements.current));
}
function pc(e, t) {
  e.framesetOk = !1;
  const u = t.tagID;
  for (let a = e.openElements.stackTop; a >= 0; a--) {
    const r = e.openElements.tagIDs[a];
    if (u === s.LI && r === s.LI || (u === s.DD || u === s.DT) && (r === s.DD || r === s.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.popUntilTagNamePopped(r);
      break;
    }
    if (r !== s.ADDRESS && r !== s.DIV && r !== s.P && e._isSpecialElement(e.openElements.items[a], r))
      break;
  }
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, b.HTML);
}
function gc(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, b.HTML), e.tokenizer.state = H.PLAINTEXT;
}
function Nc(e, t) {
  e.openElements.hasInScope(s.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(s.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, b.HTML), e.framesetOk = !1;
}
function Cc(e, t) {
  const u = e.activeFormattingElements.getElementEntryInScopeWithTagName(f.A);
  u && (qt(e, t), e.openElements.remove(u.element), e.activeFormattingElements.removeEntry(u)), e._reconstructActiveFormattingElements(), e._insertElement(t, b.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Ic(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, b.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Sc(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(s.NOBR) && (qt(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, b.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Oc(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, b.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function Lc(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== v.QUIRKS && e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._insertElement(t, b.HTML), e.framesetOk = !1, e.insertionMode = d.IN_TABLE;
}
function ga(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, b.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function Na(e) {
  const t = da(e, J.TYPE);
  return t != null && t.toLowerCase() === Gi;
}
function Dc(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, b.HTML), Na(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function Rc(e, t) {
  e._appendElement(t, b.HTML), t.ackSelfClosing = !0;
}
function Pc(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._appendElement(t, b.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function Mc(e, t) {
  t.tagName = f.IMG, t.tagID = s.IMG, ga(e, t);
}
function xc(e, t) {
  e._insertElement(t, b.HTML), e.skipNextNewLine = !0, e.tokenizer.state = H.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = d.TEXT;
}
function yc(e, t) {
  e.openElements.hasInButtonScope(s.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, H.RAWTEXT);
}
function Bc(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, H.RAWTEXT);
}
function bu(e, t) {
  e._switchToTextParsing(t, H.RAWTEXT);
}
function kc(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, b.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === d.IN_TABLE || e.insertionMode === d.IN_CAPTION || e.insertionMode === d.IN_TABLE_BODY || e.insertionMode === d.IN_ROW || e.insertionMode === d.IN_CELL ? d.IN_SELECT_IN_TABLE : d.IN_SELECT;
}
function Fc(e, t) {
  e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, b.HTML);
}
function Uc(e, t) {
  e.openElements.hasInScope(s.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, b.HTML);
}
function Hc(e, t) {
  e.openElements.hasInScope(s.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(s.RTC), e._insertElement(t, b.HTML);
}
function wc(e, t) {
  e._reconstructActiveFormattingElements(), ba(t), Yt(t), t.selfClosing ? e._appendElement(t, b.MATHML) : e._insertElement(t, b.MATHML), t.ackSelfClosing = !0;
}
function vc(e, t) {
  e._reconstructActiveFormattingElements(), ma(t), Yt(t), t.selfClosing ? e._appendElement(t, b.SVG) : e._insertElement(t, b.SVG), t.ackSelfClosing = !0;
}
function mu(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, b.HTML);
}
function B(e, t) {
  switch (t.tagID) {
    case s.I:
    case s.S:
    case s.B:
    case s.U:
    case s.EM:
    case s.TT:
    case s.BIG:
    case s.CODE:
    case s.FONT:
    case s.SMALL:
    case s.STRIKE:
    case s.STRONG: {
      Ic(e, t);
      break;
    }
    case s.A: {
      Cc(e, t);
      break;
    }
    case s.H1:
    case s.H2:
    case s.H3:
    case s.H4:
    case s.H5:
    case s.H6: {
      mc(e, t);
      break;
    }
    case s.P:
    case s.DL:
    case s.OL:
    case s.UL:
    case s.DIV:
    case s.DIR:
    case s.NAV:
    case s.MAIN:
    case s.MENU:
    case s.ASIDE:
    case s.CENTER:
    case s.FIGURE:
    case s.FOOTER:
    case s.HEADER:
    case s.HGROUP:
    case s.DIALOG:
    case s.DETAILS:
    case s.ADDRESS:
    case s.ARTICLE:
    case s.SEARCH:
    case s.SECTION:
    case s.SUMMARY:
    case s.FIELDSET:
    case s.BLOCKQUOTE:
    case s.FIGCAPTION: {
      bc(e, t);
      break;
    }
    case s.LI:
    case s.DD:
    case s.DT: {
      pc(e, t);
      break;
    }
    case s.BR:
    case s.IMG:
    case s.WBR:
    case s.AREA:
    case s.EMBED:
    case s.KEYGEN: {
      ga(e, t);
      break;
    }
    case s.HR: {
      Pc(e, t);
      break;
    }
    case s.RB:
    case s.RTC: {
      Uc(e, t);
      break;
    }
    case s.RT:
    case s.RP: {
      Hc(e, t);
      break;
    }
    case s.PRE:
    case s.LISTING: {
      _c(e, t);
      break;
    }
    case s.XMP: {
      yc(e, t);
      break;
    }
    case s.SVG: {
      vc(e, t);
      break;
    }
    case s.HTML: {
      hc(e, t);
      break;
    }
    case s.BASE:
    case s.LINK:
    case s.META:
    case s.STYLE:
    case s.TITLE:
    case s.SCRIPT:
    case s.BGSOUND:
    case s.BASEFONT:
    case s.TEMPLATE: {
      Y(e, t);
      break;
    }
    case s.BODY: {
      Ec(e, t);
      break;
    }
    case s.FORM: {
      Ac(e, t);
      break;
    }
    case s.NOBR: {
      Sc(e, t);
      break;
    }
    case s.MATH: {
      wc(e, t);
      break;
    }
    case s.TABLE: {
      Lc(e, t);
      break;
    }
    case s.INPUT: {
      Dc(e, t);
      break;
    }
    case s.PARAM:
    case s.TRACK:
    case s.SOURCE: {
      Rc(e, t);
      break;
    }
    case s.IMAGE: {
      Mc(e, t);
      break;
    }
    case s.BUTTON: {
      Nc(e, t);
      break;
    }
    case s.APPLET:
    case s.OBJECT:
    case s.MARQUEE: {
      Oc(e, t);
      break;
    }
    case s.IFRAME: {
      Bc(e, t);
      break;
    }
    case s.SELECT: {
      kc(e, t);
      break;
    }
    case s.OPTION:
    case s.OPTGROUP: {
      Fc(e, t);
      break;
    }
    case s.NOEMBED:
    case s.NOFRAMES: {
      bu(e, t);
      break;
    }
    case s.FRAMESET: {
      Tc(e, t);
      break;
    }
    case s.TEXTAREA: {
      xc(e, t);
      break;
    }
    case s.NOSCRIPT: {
      e.options.scriptingEnabled ? bu(e, t) : mu(e, t);
      break;
    }
    case s.PLAINTEXT: {
      gc(e, t);
      break;
    }
    case s.COL:
    case s.TH:
    case s.TD:
    case s.TR:
    case s.HEAD:
    case s.FRAME:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
    case s.CAPTION:
    case s.COLGROUP:
      break;
    default:
      mu(e, t);
  }
}
function Yc(e, t) {
  if (e.openElements.hasInScope(s.BODY) && (e.insertionMode = d.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const u = e.openElements.tryPeekProperlyNestedBodyElement();
    u && e._setEndLocation(u, t);
  }
}
function qc(e, t) {
  e.openElements.hasInScope(s.BODY) && (e.insertionMode = d.AFTER_BODY, xa(e, t));
}
function Wc(e, t) {
  const u = t.tagID;
  e.openElements.hasInScope(u) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(u));
}
function Qc(e) {
  const t = e.openElements.tmplCount > 0, { formElement: u } = e;
  t || (e.formElement = null), (u || t) && e.openElements.hasInScope(s.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(s.FORM) : u && e.openElements.remove(u));
}
function Gc(e) {
  e.openElements.hasInButtonScope(s.P) || e._insertFakeElement(f.P, s.P), e._closePElement();
}
function Vc(e) {
  e.openElements.hasInListItemScope(s.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(s.LI), e.openElements.popUntilTagNamePopped(s.LI));
}
function Xc(e, t) {
  const u = t.tagID;
  e.openElements.hasInScope(u) && (e.openElements.generateImpliedEndTagsWithExclusion(u), e.openElements.popUntilTagNamePopped(u));
}
function Kc(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function jc(e, t) {
  const u = t.tagID;
  e.openElements.hasInScope(u) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(u), e.activeFormattingElements.clearToLastMarker());
}
function $c(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(f.BR, s.BR), e.openElements.pop(), e.framesetOk = !1;
}
function Ca(e, t) {
  const u = t.tagName, a = t.tagID;
  for (let r = e.openElements.stackTop; r > 0; r--) {
    const n = e.openElements.items[r], c = e.openElements.tagIDs[r];
    if (a === c && (a !== s.UNKNOWN || e.treeAdapter.getTagName(n) === u)) {
      e.openElements.generateImpliedEndTagsWithExclusion(a), e.openElements.stackTop >= r && e.openElements.shortenToLength(r);
      break;
    }
    if (e._isSpecialElement(n, c))
      break;
  }
}
function et(e, t) {
  switch (t.tagID) {
    case s.A:
    case s.B:
    case s.I:
    case s.S:
    case s.U:
    case s.EM:
    case s.TT:
    case s.BIG:
    case s.CODE:
    case s.FONT:
    case s.NOBR:
    case s.SMALL:
    case s.STRIKE:
    case s.STRONG: {
      qt(e, t);
      break;
    }
    case s.P: {
      Gc(e);
      break;
    }
    case s.DL:
    case s.UL:
    case s.OL:
    case s.DIR:
    case s.DIV:
    case s.NAV:
    case s.PRE:
    case s.MAIN:
    case s.MENU:
    case s.ASIDE:
    case s.BUTTON:
    case s.CENTER:
    case s.FIGURE:
    case s.FOOTER:
    case s.HEADER:
    case s.HGROUP:
    case s.DIALOG:
    case s.ADDRESS:
    case s.ARTICLE:
    case s.DETAILS:
    case s.SEARCH:
    case s.SECTION:
    case s.SUMMARY:
    case s.LISTING:
    case s.FIELDSET:
    case s.BLOCKQUOTE:
    case s.FIGCAPTION: {
      Wc(e, t);
      break;
    }
    case s.LI: {
      Vc(e);
      break;
    }
    case s.DD:
    case s.DT: {
      Xc(e, t);
      break;
    }
    case s.H1:
    case s.H2:
    case s.H3:
    case s.H4:
    case s.H5:
    case s.H6: {
      Kc(e);
      break;
    }
    case s.BR: {
      $c(e);
      break;
    }
    case s.BODY: {
      Yc(e, t);
      break;
    }
    case s.HTML: {
      qc(e, t);
      break;
    }
    case s.FORM: {
      Qc(e);
      break;
    }
    case s.APPLET:
    case s.OBJECT:
    case s.MARQUEE: {
      jc(e, t);
      break;
    }
    case s.TEMPLATE: {
      ae(e, t);
      break;
    }
    default:
      Ca(e, t);
  }
}
function Ia(e, t) {
  e.tmplInsertionModeStack.length > 0 ? Ma(e, t) : Wt(e, t);
}
function zc(e, t) {
  var u;
  t.tagID === s.SCRIPT && ((u = e.scriptHandler) === null || u === void 0 || u.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function Jc(e, t) {
  e._err(t, E.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function Et(e, t) {
  if (_a.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = d.IN_TABLE_TEXT, t.type) {
      case O.CHARACTER: {
        Oa(e, t);
        break;
      }
      case O.WHITESPACE_CHARACTER: {
        Sa(e, t);
        break;
      }
    }
  else
    De(e, t);
}
function Zc(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, b.HTML), e.insertionMode = d.IN_CAPTION;
}
function e0(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, b.HTML), e.insertionMode = d.IN_COLUMN_GROUP;
}
function t0(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(f.COLGROUP, s.COLGROUP), e.insertionMode = d.IN_COLUMN_GROUP, Qt(e, t);
}
function u0(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, b.HTML), e.insertionMode = d.IN_TABLE_BODY;
}
function a0(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(f.TBODY, s.TBODY), e.insertionMode = d.IN_TABLE_BODY, tt(e, t);
}
function s0(e, t) {
  e.openElements.hasInTableScope(s.TABLE) && (e.openElements.popUntilTagNamePopped(s.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function r0(e, t) {
  Na(t) ? e._appendElement(t, b.HTML) : De(e, t), t.ackSelfClosing = !0;
}
function n0(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, b.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function ne(e, t) {
  switch (t.tagID) {
    case s.TD:
    case s.TH:
    case s.TR: {
      a0(e, t);
      break;
    }
    case s.STYLE:
    case s.SCRIPT:
    case s.TEMPLATE: {
      Y(e, t);
      break;
    }
    case s.COL: {
      t0(e, t);
      break;
    }
    case s.FORM: {
      n0(e, t);
      break;
    }
    case s.TABLE: {
      s0(e, t);
      break;
    }
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      u0(e, t);
      break;
    }
    case s.INPUT: {
      r0(e, t);
      break;
    }
    case s.CAPTION: {
      Zc(e, t);
      break;
    }
    case s.COLGROUP: {
      e0(e, t);
      break;
    }
    default:
      De(e, t);
  }
}
function Se(e, t) {
  switch (t.tagID) {
    case s.TABLE: {
      e.openElements.hasInTableScope(s.TABLE) && (e.openElements.popUntilTagNamePopped(s.TABLE), e._resetInsertionMode());
      break;
    }
    case s.TEMPLATE: {
      ae(e, t);
      break;
    }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TBODY:
    case s.TD:
    case s.TFOOT:
    case s.TH:
    case s.THEAD:
    case s.TR:
      break;
    default:
      De(e, t);
  }
}
function De(e, t) {
  const u = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, Ze(e, t), e.fosterParentingEnabled = u;
}
function Sa(e, t) {
  e.pendingCharacterTokens.push(t);
}
function Oa(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function he(e, t) {
  let u = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; u < e.pendingCharacterTokens.length; u++)
      De(e, e.pendingCharacterTokens[u]);
  else
    for (; u < e.pendingCharacterTokens.length; u++)
      e._insertCharacters(e.pendingCharacterTokens[u]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const La = /* @__PURE__ */ new Set([s.CAPTION, s.COL, s.COLGROUP, s.TBODY, s.TD, s.TFOOT, s.TH, s.THEAD, s.TR]);
function i0(e, t) {
  const u = t.tagID;
  La.has(u) ? e.openElements.hasInTableScope(s.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(s.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = d.IN_TABLE, ne(e, t)) : B(e, t);
}
function c0(e, t) {
  const u = t.tagID;
  switch (u) {
    case s.CAPTION:
    case s.TABLE: {
      e.openElements.hasInTableScope(s.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(s.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = d.IN_TABLE, u === s.TABLE && Se(e, t));
      break;
    }
    case s.BODY:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TBODY:
    case s.TD:
    case s.TFOOT:
    case s.TH:
    case s.THEAD:
    case s.TR:
      break;
    default:
      et(e, t);
  }
}
function Qt(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      B(e, t);
      break;
    }
    case s.COL: {
      e._appendElement(t, b.HTML), t.ackSelfClosing = !0;
      break;
    }
    case s.TEMPLATE: {
      Y(e, t);
      break;
    }
    default:
      Qe(e, t);
  }
}
function o0(e, t) {
  switch (t.tagID) {
    case s.COLGROUP: {
      e.openElements.currentTagId === s.COLGROUP && (e.openElements.pop(), e.insertionMode = d.IN_TABLE);
      break;
    }
    case s.TEMPLATE: {
      ae(e, t);
      break;
    }
    case s.COL:
      break;
    default:
      Qe(e, t);
  }
}
function Qe(e, t) {
  e.openElements.currentTagId === s.COLGROUP && (e.openElements.pop(), e.insertionMode = d.IN_TABLE, e._processToken(t));
}
function tt(e, t) {
  switch (t.tagID) {
    case s.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, b.HTML), e.insertionMode = d.IN_ROW;
      break;
    }
    case s.TH:
    case s.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(f.TR, s.TR), e.insertionMode = d.IN_ROW, ut(e, t);
      break;
    }
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = d.IN_TABLE, ne(e, t));
      break;
    }
    default:
      ne(e, t);
  }
}
function Ct(e, t) {
  const u = t.tagID;
  switch (t.tagID) {
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      e.openElements.hasInTableScope(u) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = d.IN_TABLE);
      break;
    }
    case s.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = d.IN_TABLE, Se(e, t));
      break;
    }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TD:
    case s.TH:
    case s.TR:
      break;
    default:
      Se(e, t);
  }
}
function ut(e, t) {
  switch (t.tagID) {
    case s.TH:
    case s.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, b.HTML), e.insertionMode = d.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
    case s.TR: {
      e.openElements.hasInTableScope(s.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = d.IN_TABLE_BODY, tt(e, t));
      break;
    }
    default:
      ne(e, t);
  }
}
function Da(e, t) {
  switch (t.tagID) {
    case s.TR: {
      e.openElements.hasInTableScope(s.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = d.IN_TABLE_BODY);
      break;
    }
    case s.TABLE: {
      e.openElements.hasInTableScope(s.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = d.IN_TABLE_BODY, Ct(e, t));
      break;
    }
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(s.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = d.IN_TABLE_BODY, Ct(e, t));
      break;
    }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
    case s.TD:
    case s.TH:
      break;
    default:
      Se(e, t);
  }
}
function d0(e, t) {
  const u = t.tagID;
  La.has(u) ? (e.openElements.hasInTableScope(s.TD) || e.openElements.hasInTableScope(s.TH)) && (e._closeTableCell(), ut(e, t)) : B(e, t);
}
function l0(e, t) {
  const u = t.tagID;
  switch (u) {
    case s.TD:
    case s.TH: {
      e.openElements.hasInTableScope(u) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(u), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = d.IN_ROW);
      break;
    }
    case s.TABLE:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD:
    case s.TR: {
      e.openElements.hasInTableScope(u) && (e._closeTableCell(), Da(e, t));
      break;
    }
    case s.BODY:
    case s.CAPTION:
    case s.COL:
    case s.COLGROUP:
    case s.HTML:
      break;
    default:
      et(e, t);
  }
}
function Ra(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      B(e, t);
      break;
    }
    case s.OPTION: {
      e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e._insertElement(t, b.HTML);
      break;
    }
    case s.OPTGROUP: {
      e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e.openElements.currentTagId === s.OPTGROUP && e.openElements.pop(), e._insertElement(t, b.HTML);
      break;
    }
    case s.HR: {
      e.openElements.currentTagId === s.OPTION && e.openElements.pop(), e.openElements.currentTagId === s.OPTGROUP && e.openElements.pop(), e._appendElement(t, b.HTML), t.ackSelfClosing = !0;
      break;
    }
    case s.INPUT:
    case s.KEYGEN:
    case s.TEXTAREA:
    case s.SELECT: {
      e.openElements.hasInSelectScope(s.SELECT) && (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode(), t.tagID !== s.SELECT && e._processStartTag(t));
      break;
    }
    case s.SCRIPT:
    case s.TEMPLATE: {
      Y(e, t);
      break;
    }
  }
}
function Pa(e, t) {
  switch (t.tagID) {
    case s.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === s.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === s.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === s.OPTGROUP && e.openElements.pop();
      break;
    }
    case s.OPTION: {
      e.openElements.currentTagId === s.OPTION && e.openElements.pop();
      break;
    }
    case s.SELECT: {
      e.openElements.hasInSelectScope(s.SELECT) && (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode());
      break;
    }
    case s.TEMPLATE: {
      ae(e, t);
      break;
    }
  }
}
function f0(e, t) {
  const u = t.tagID;
  u === s.CAPTION || u === s.TABLE || u === s.TBODY || u === s.TFOOT || u === s.THEAD || u === s.TR || u === s.TD || u === s.TH ? (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : Ra(e, t);
}
function h0(e, t) {
  const u = t.tagID;
  u === s.CAPTION || u === s.TABLE || u === s.TBODY || u === s.TFOOT || u === s.THEAD || u === s.TR || u === s.TD || u === s.TH ? e.openElements.hasInTableScope(u) && (e.openElements.popUntilTagNamePopped(s.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : Pa(e, t);
}
function E0(e, t) {
  switch (t.tagID) {
    case s.BASE:
    case s.BASEFONT:
    case s.BGSOUND:
    case s.LINK:
    case s.META:
    case s.NOFRAMES:
    case s.SCRIPT:
    case s.STYLE:
    case s.TEMPLATE:
    case s.TITLE: {
      Y(e, t);
      break;
    }
    case s.CAPTION:
    case s.COLGROUP:
    case s.TBODY:
    case s.TFOOT:
    case s.THEAD: {
      e.tmplInsertionModeStack[0] = d.IN_TABLE, e.insertionMode = d.IN_TABLE, ne(e, t);
      break;
    }
    case s.COL: {
      e.tmplInsertionModeStack[0] = d.IN_COLUMN_GROUP, e.insertionMode = d.IN_COLUMN_GROUP, Qt(e, t);
      break;
    }
    case s.TR: {
      e.tmplInsertionModeStack[0] = d.IN_TABLE_BODY, e.insertionMode = d.IN_TABLE_BODY, tt(e, t);
      break;
    }
    case s.TD:
    case s.TH: {
      e.tmplInsertionModeStack[0] = d.IN_ROW, e.insertionMode = d.IN_ROW, ut(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = d.IN_BODY, e.insertionMode = d.IN_BODY, B(e, t);
  }
}
function T0(e, t) {
  t.tagID === s.TEMPLATE && ae(e, t);
}
function Ma(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(s.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : Wt(e, t);
}
function b0(e, t) {
  t.tagID === s.HTML ? B(e, t) : Ge(e, t);
}
function xa(e, t) {
  var u;
  if (t.tagID === s.HTML) {
    if (e.fragmentContext || (e.insertionMode = d.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === s.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const a = e.openElements.items[1];
      a && !(!((u = e.treeAdapter.getNodeSourceCodeLocation(a)) === null || u === void 0) && u.endTag) && e._setEndLocation(a, t);
    }
  } else
    Ge(e, t);
}
function Ge(e, t) {
  e.insertionMode = d.IN_BODY, Ze(e, t);
}
function m0(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      B(e, t);
      break;
    }
    case s.FRAMESET: {
      e._insertElement(t, b.HTML);
      break;
    }
    case s.FRAME: {
      e._appendElement(t, b.HTML), t.ackSelfClosing = !0;
      break;
    }
    case s.NOFRAMES: {
      Y(e, t);
      break;
    }
  }
}
function _0(e, t) {
  t.tagID === s.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== s.FRAMESET && (e.insertionMode = d.AFTER_FRAMESET));
}
function A0(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      B(e, t);
      break;
    }
    case s.NOFRAMES: {
      Y(e, t);
      break;
    }
  }
}
function p0(e, t) {
  t.tagID === s.HTML && (e.insertionMode = d.AFTER_AFTER_FRAMESET);
}
function g0(e, t) {
  t.tagID === s.HTML ? B(e, t) : Be(e, t);
}
function Be(e, t) {
  e.insertionMode = d.IN_BODY, Ze(e, t);
}
function N0(e, t) {
  switch (t.tagID) {
    case s.HTML: {
      B(e, t);
      break;
    }
    case s.NOFRAMES: {
      Y(e, t);
      break;
    }
  }
}
function C0(e, t) {
  t.chars = D, e._insertCharacters(t);
}
function I0(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function ya(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== b.HTML && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function S0(e, t) {
  if (vi(t))
    ya(e), e._startTagOutsideForeignContent(t);
  else {
    const u = e._getAdjustedCurrentElement(), a = e.treeAdapter.getNamespaceURI(u);
    a === b.MATHML ? ba(t) : a === b.SVG && (Yi(t), ma(t)), Yt(t), t.selfClosing ? e._appendElement(t, a) : e._insertElement(t, a), t.ackSelfClosing = !0;
  }
}
function O0(e, t) {
  if (t.tagID === s.P || t.tagID === s.BR) {
    ya(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let u = e.openElements.stackTop; u > 0; u--) {
    const a = e.openElements.items[u];
    if (e.treeAdapter.getNamespaceURI(a) === b.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const r = e.treeAdapter.getTagName(a);
    if (r.toLowerCase() === t.tagName) {
      t.tagName = r, e.openElements.shortenToLength(u);
      break;
    }
  }
}
const L0 = /* @__PURE__ */ new Set([
  f.AREA,
  f.BASE,
  f.BASEFONT,
  f.BGSOUND,
  f.BR,
  f.COL,
  f.EMBED,
  f.FRAME,
  f.HR,
  f.IMG,
  f.INPUT,
  f.KEYGEN,
  f.LINK,
  f.META,
  f.PARAM,
  f.SOURCE,
  f.TRACK,
  f.WBR
]);
function D0(e, t) {
  return t.treeAdapter.isElementNode(e) && t.treeAdapter.getNamespaceURI(e) === b.HTML && L0.has(t.treeAdapter.getTagName(e));
}
const R0 = { treeAdapter: W, scriptingEnabled: !0 };
function v0(e, t) {
  const u = { ...R0, ...t };
  return Ba(e, u);
}
function P0(e, t) {
  let u = "";
  const a = t.treeAdapter.isElementNode(e) && t.treeAdapter.getTagName(e) === f.TEMPLATE && t.treeAdapter.getNamespaceURI(e) === b.HTML ? t.treeAdapter.getTemplateContent(e) : e, r = t.treeAdapter.getChildNodes(a);
  if (r)
    for (const n of r)
      u += Ba(n, t);
  return u;
}
function Ba(e, t) {
  return t.treeAdapter.isElementNode(e) ? M0(e, t) : t.treeAdapter.isTextNode(e) ? y0(e, t) : t.treeAdapter.isCommentNode(e) ? B0(e, t) : t.treeAdapter.isDocumentTypeNode(e) ? k0(e, t) : "";
}
function M0(e, t) {
  const u = t.treeAdapter.getTagName(e);
  return `<${u}${x0(e, t)}>${D0(e, t) ? "" : `${P0(e, t)}</${u}>`}`;
}
function x0(e, { treeAdapter: t }) {
  let u = "";
  for (const a of t.getAttrList(e)) {
    if (u += " ", a.namespace)
      switch (a.namespace) {
        case b.XML: {
          u += `xml:${a.name}`;
          break;
        }
        case b.XMLNS: {
          a.name !== "xmlns" && (u += "xmlns:"), u += a.name;
          break;
        }
        case b.XLINK: {
          u += `xlink:${a.name}`;
          break;
        }
        default:
          u += `${a.prefix}:${a.name}`;
      }
    else
      u += a.name;
    u += `="${Su(a.value)}"`;
  }
  return u;
}
function y0(e, t) {
  const { treeAdapter: u } = t, a = u.getTextNodeContent(e), r = u.getParentNode(e), n = r && u.isElementNode(r) && u.getTagName(r);
  return n && u.getNamespaceURI(r) === b.HTML && Ei(n, t.scriptingEnabled) ? a : Ou(a);
}
function B0(e, { treeAdapter: t }) {
  return `<!--${t.getCommentNodeContent(e)}-->`;
}
function k0(e, { treeAdapter: t }) {
  return `<!DOCTYPE ${t.getDocumentTypeNodeName(e)}>`;
}
export {
  Xa as C,
  Ot as D,
  L as E,
  Ka as P,
  Au as T,
  $a as a,
  ja as b,
  ze as c,
  ur as d,
  w0 as e,
  Vs as f,
  Lt as g,
  p as h,
  oe as i,
  Z as j,
  v as k,
  za as l,
  te as m,
  v0 as n,
  gu as o,
  pu as p,
  Q as q,
  es as r,
  U0 as s,
  H0 as t,
  Dt as u,
  Ja as x
};
//# sourceMappingURL=index-C-My4wxZ.mjs.map
